/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import { Box, Grid, CircularProgress, Typography, useMediaQuery } from "@mui/material";
import update from "immutability-helper";
import _, { uniqueId } from "lodash";
import { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import styles from "../assets/styles/Hospital.module.scss";
import Page from "../components/Page";
import dashboardStyles from "../components/dashboard/Dashboard.module.scss";
import InsuranceCard from "../components/dashboard/InsuranceCard/InsuranceCard";
import Card from "../components/dashboard/card/Card";
import {
	CommunityTransferCardDetailsDialog,
	CommunityTransferHeader,
	SafeDischargeAssLivingSlider,
	SelectableCardCoTransfer,
	SixtyDaysAnalysis,
	SNFFacilitySlider,
	TotalCoTransferCard,
} from "../features/community-transfer/components";
import CommunityTransferHeaderCardFilterPanel from "../features/community-transfer/components/CommunityTransferHeaderCardFilterPanel";
import DoctorCard from "../components/dashboard/doctorCard/DoctorCard";
import {
	FloorCardList,
	ReturnCardList,
	TotalCountCircle,
} from "../features/hospital/components";
import TaggedList from "../components/dashboard/shared/taggedList/TaggedList";
import usePdfReport from "../components/hooks/usePdfReport";
import ColorInfoBox from "../components/shared/dashboard/ColorInfoBox";
import DragDropLayout from "../components/shared/DragDropLayout";
import LayoutController from "../components/shared/LayoutController";
import ToastNotification from "../components/shared/ToastNotification";
import { getAllCommunicationPatient } from "../services/community-transfer.service";
import {
	DEFAULT_COMMUNITY_DATA,
	openDetailsDialog,
	setCardFilterCommunity,
	setDynamicCards,
	setIsSpecialComparison,
	setLockTotal,
	setLockedTotalBy,
	setMainTotal,
	setResetFilter,
	setTransferType,
	setLoading as setCommunityLoading,
	setCachedMainResult,
	setCachedComparisonResult,
	clearCachedResults,
} from "../store/reducers/community-transfer.slice";
import {
	openDetailsDialog as openDetailsDialogComparison,
	setCardFilterCommunity as setCardFilterComparison,
	setFilterListDataCommunity as setFilterListDataComparison,
	setMainTotal as setMainTotalComparison,
	setPatientList as setPatientListComparison,
	setTransferType as setTransferTypeComparison,
} from "../store/reducers/comparisonReducers/communityTransferComparison.slice";
import { setCardExpandState } from "../store/reducers/dataCardsExpand.slice";
import { setCommunityTransferLayout } from "../store/reducers/customCard.slice";
import { PATIENT_RELATION } from "../types/chart-dialog.type";
import { CO_TRANSFER_CARDS_TYPE, COMMUNITY_CARD_LABELS, TRANSFER_TYPE } from "../types/community-transfer.type";
import { PAGE_TYPE } from "../types/pages.type";
import {
	calcProPercentsBasedOnFilterAndDays,
	getDynamicPercentageBy,
	getPercentageByTotal,
	isFullAccess,
	isOnlyHospitalOrTransfer,
	isOnlyHospitalTabAccess,
	itemPercentage,
	pickObjectByPaths,
	priorityFilter,
	processCustomRangeCombinedData,
	projectionPerMonth,
	selectedTabAccess,
	updateChartFilterByPriority,
	updateCurrentFilterListData,
} from "../utilis/common";
import { updateFilterListData } from "../utilis/community-common";
import { toSaveDate, toSaveEndDate } from "../utilis/date-formats";
import tooltipsInfo from "../utilis/tooltipContents";

import { setCommunityTransferCards } from "../store/reducers/customCard.slice";
import AddCardDrawer from "../components/shared/add-filter-card/add-card-drawer";
import { COMMUNITY_CUSTOM_CARD } from "../types/custom-card-type";
import CardAnimation from "../components/shared/CardAnimation";
import ShadowLineWithText from "../components/shared/ShadowLineWithText";
import NoteContainer from "../components/shared/NoteContainer";
import { getQuestionsData } from "../services/dynamic-data-tab.service";
import { ADT_SUB_TYPES } from "../types/common.type";
import useAdditionalData from "../components/hooks/useAdditionalData";
import useSharedUsersByCustomTab from "../hooks/useSharedUsersByCustomTab";
import { useDashboard } from "../context/DashboardContext";
import DynamicCardItem from "../components/shared/dynamic-card/DynamicCardItem";
import { usePageLayoutFetch } from "../hooks/usePageLayoutFetch";
import useAddCategoryFromMenu from "../hooks/useAddCategoryFromMenu";
import { usePageNotifications } from "../hooks/usePageNotifications";
import ShareNotificationDialog from "../components/shared/ShareNotificationDialog";
import { getCardWidth } from "../constants/card-layout";
import {
	getCustomTabCardLayoutId,
	getDynamicCardLayoutId,
	resolveLayoutCardIdForSelectedCard,
} from "../utilis/layout-card-ids";
import CategoryBox from "../components/shared/CategoryBox";
import CommunityTransferCardLayoutPreview from "../features/community-transfer/components/layoutPreview/CommunityTransferCardLayoutPreview";
import { ensureHospitalRootOrder } from "../utils/ensureHospitalRootOrder";
import {
	computeLayoutAfterCardMove,
	computeLayoutAfterRootGapInsert,
	estimateCategoryGridRowUnits,
	getPointerClientCoords,
	getStandaloneInsertBeforeIdFromPoint,
	getCategoryInsertBeforeTargetFromPoint,
	pointInRect,
	pointerOverHospitalRootStandaloneArea,
	resolveHospitalCategoryIdUnderPointer,
} from "../utils/hospitalCategoryLayoutHelpers";
import { saveLayoutToDatabase } from "../services/layout.service";
import {
	applyCollapsedStateToLayout,
	getCollapsedIdsFromLayout,
} from "../utils/categoryCollapsedState";
import useCollapsedCategoriesPersistence from "../components/hooks/useCollapsedCategoriesPersistence";
import { findCategoryIdContainingCard } from "../utils/dashboardScrollToCard";
import { ADD_NOTIFICATION, REPORT_META_PATHS } from "../store/types";
import { AUTH_ROLES } from "../types/auth.type";
import { setIsLayoutMode } from "../store/reducers/common.slice";
import MobileCardList from "../components/shared/MobileCardList";
import { MobileTransferCarousel } from "../features/community-transfer/components";
import { HospitalList } from "../features/admissions/components";
import { NinetyDaysAnalysis, DayCardList } from "../features/hospital/components";
import AiChatFloatButton from "../components/shared/ai-chat/AiChatFloatButton";
import AiChatDrawer from "../components/shared/ai-chat/AiChatDrawer";
import { useAIChatContext } from "../hooks/useAIChatContext";
import { useAiChatAccess } from "../hooks/useAiChatAccess";
import { registerVectorStoreId } from "../services/vector-store-tracking.service";
import { persistCommunityPageConverterCardContext } from "../services/page-converter-navigation.service";
// import aiCensusActionsService from "../services/ai-census-actions.service";
// import aiDateSuggestionsService from "../services/ai-date-suggestions.service";
// import aiDateActionsService from "../services/ai-date-actions.service";
// import aiFilterActionsService from "../services/ai-filter-actions.service";
// import aiReportActionsService from "../services/ai-report-actions.service";
// import aiTransferActionsService from "../services/ai-transfer-actions.service";
// import aiDialogActionsService from "../services/ai-dialog-actions.service";
import { chartsData, chartGroupBy } from "../utilis/charts-common";
import useFilterTutorial from "../hooks/useFilterTutorial";
import useFacilityId from "../hooks/useFacilityId";
import useAccountId from "../hooks/useAccountId";
import useShareReport from "../hooks/useShareReport";
import ShareNotesDialog from "../components/shared/notes/ShareNotesDialog";

/**
 * Layout mode dashboard zoom (`transform: scale(z)` + matching `width: calc(100%/z)`).
 * Same factors as Hospital so drag math (`transformScale` on RGL) matches the visual scale.
 */
const COMMUNITY_TRANSFER_LAYOUT_MODE_ZOOM_DESKTOP = 0.76;
const COMMUNITY_TRANSFER_LAYOUT_MODE_ZOOM_MOBILE = 0.86;

const DEFAULT_LIST = {
	sixtyDaysData: [],
	list: [],
};

function normalizeCommunityTransferLayoutCardIds(layout, dynamicCards, customTabs) {
	if (!layout) return layout;
	const mapCard = (c) => {
		if (!c || c.id == null) return c;
		const newId = resolveLayoutCardIdForSelectedCard(c.id, dynamicCards, customTabs);
		return newId === c.id ? c : { ...c, id: newId };
	};
	const mappedRootOrder = Array.isArray(layout.rootOrder)
		? layout.rootOrder
			.map((entry) => {
				if (!entry || entry.id == null) return entry;
				const nextId = resolveLayoutCardIdForSelectedCard(entry.id, dynamicCards, customTabs);
				return nextId === entry.id ? entry : { ...entry, id: nextId };
			})
			.filter(Boolean)
		: undefined;
	return {
		...layout,
		standalone: (layout.standalone || []).map(mapCard),
		categories: (layout.categories || []).map((cat) => ({
			...cat,
			cards: (cat.cards || []).map(mapCard),
		})),
		rootOrder: mappedRootOrder,
	};
}

function augmentCommunityTransferLayoutWithSelectedCards(layout, communityTransferCards, dynamicCards, customTabs) {
	if (!layout || !Array.isArray(communityTransferCards) || communityTransferCards.length === 0) return layout;
	
	const ownedBaseAccessors = new Set();
	
	// Process categories first to prioritize cards explicitly placed there
	const cleanCategories = (layout.categories || []).map(cat => {
		const cleanCards = [];
		(cat.cards || []).forEach(c => {
			const base = c.id.replace(/^(dynamic_|custom_)/, '');
			if (!ownedBaseAccessors.has(base)) {
				ownedBaseAccessors.add(base);
				cleanCards.push(c);
			}
		});
		return { ...cat, cards: cleanCards };
	});

	// Remove duplicates from standalone
	const cleanStandalone = [];
	(layout.standalone || []).forEach(c => {
		const base = c.id.replace(/^(dynamic_|custom_)/, '');
		if (!ownedBaseAccessors.has(base)) {
			ownedBaseAccessors.add(base);
			cleanStandalone.push(c);
		}
	});

	// Find truly missing cards
	const additions = [];
	for (const cId of communityTransferCards) {
		const base = cId.replace(/^(dynamic_|custom_)/, '');
		if (!ownedBaseAccessors.has(base)) {
			ownedBaseAccessors.add(base);
			const gridId = resolveLayoutCardIdForSelectedCard(cId, dynamicCards, customTabs);
			additions.push({ id: gridId, width: getCardWidth(cId), gridH: 24 });
		}
	}

	const existingRootOrder = Array.isArray(layout.rootOrder) ? layout.rootOrder : [];
	const validStandaloneIds = new Set(cleanStandalone.map(c => c.id));
	const orderedIds = new Set();
	
	// Clean root order of duplicates that were removed
	const cleanRootOrder = existingRootOrder.filter(entry => {
		if (entry.type === 'category') {
			orderedIds.add(entry.id);
			return true;
		}
		if (validStandaloneIds.has(entry.id)) {
			orderedIds.add(entry.id);
			return true;
		}
		return false;
	});

	const appendedRootEntries = additions
		.filter((card) => !orderedIds.has(card.id))
		.map((card, idx) => ({
			id: card.id,
			type: "card",
			width: card.width || 4,
			position: cleanRootOrder.length + idx,
		}));

	const nextRootOrder = [...cleanRootOrder, ...appendedRootEntries].map((entry, idx) => ({
		...entry,
		position: idx,
	}));

	return {
		...layout,
		categories: cleanCategories,
		standalone: [...cleanStandalone, ...additions],
		rootOrder: nextRootOrder,
	};
}

function isStoredLayoutV3(layout) {
	return layout && typeof layout === "object" && !Array.isArray(layout) && layout.version === "3.0";
}

function shouldLoadLayoutFromDatabase(layout) {
	if (layout == null) return true;
	if (Array.isArray(layout)) return layout.length === 0;
	if (typeof layout === "object" && !Array.isArray(layout) && Object.keys(layout).length === 0) {
		return true;
	}
	return false;
}

const CommunityTransferPage = (props) => {
	const dispatch = useDispatch();
	const isMobile = useMediaQuery('(max-width: 768px)');
	const isMd = useMediaQuery("(max-width:1280px)");
	const categoryInnerTwoCol = !isMobile && isMd;
	const mobileMenuOpen = useSelector(state => state.ui.mobileMenuOpen);
	const { downloadPdf, saveAutomaticReport, downloadExcel } = usePdfReport();

	const [patientList, setPatientList] = useState(DEFAULT_LIST);
	const [filterListData, setFilterListData] = useState(DEFAULT_COMMUNITY_DATA);
	const [pageConverterPatientSource, setPageConverterPatientSource] = useState(null);
	const [isHeaderVisible, setIsHeaderVisible] = useState(true);
	const { lastADTDate, projectionDays, isCustomTabAdded, isLayoutMode, skipMainFetch } = useSelector((state) => state.common);
	const { rangesSet, comparingAgainstDifferentFacility, comparisonRanges } = useSelector((state) => state.comparison);
	const { communityTransferCards, communityTransferLayout } = useSelector((state) => state.customCard);
	const {
		filterListData: filterListDataComparison,
		dbData: dbDataComparison,
		filter: filterComparison,
		cardFilter: cardFilterComparison,
		transferType: transferTypeComparison,
		patientList: patientListComparison,
		filterTotal: filterTotalComparison,
		facilityPercentage: facilityPercentageComparison,
		lockedTotal: lockedTotalComparison,
		lockedByFacility: lockedByFacilityComparison,
		isCensusTotalLocked: isCensusTotalLockedComparison,
	} = useSelector((state) => state.communityTransferComparison);
	const {
		filter,
		dbData,
		transferType,
		cardFilter,
		detailsDialog,
		isResetFilter,
		lockedTotal,
		facilityPercentage,
		lockedByFacility,
		isCensusTotalLocked,
		specialComparisonSet,
		filterTotal,
		lockedTotalBy,
		loading: communityLoading,
		dynamicCards,
		cachedMainResults,
		cachedComparisonResults,
	} = useSelector((state) => state.communityTransfer);
	const { selectedAccount, percentageBy } = useSelector((state) => state.common);
	const COMMUNITY_CUSTOM_CARD_DATA = useAdditionalData(dynamicCards, COMMUNITY_CUSTOM_CARD, patientList?.customTabs);
	const { sharedUsersByTabId: sharedUsersByCustomTabId, sharedWithEveryoneByTabId } = useSharedUsersByCustomTab(
		patientList?.customTabs,
		dynamicCards
	);

	// Layout mode state
	const [hasLayoutChanges, setHasLayoutChanges] = useState(false);
	const [tempLayout, setTempLayout] = useState([]);
	const [currentLayoutType, setCurrentLayoutType] = useState('personal');
	const { fetchSavedLayout, fetchLayoutByType, fetchDefaultLayout } = usePageLayoutFetch(PAGE_TYPE.COMMUNITY_TRANSFER);
	const [layoutTypeLoading, setLayoutTypeLoading] = useState(false);
	const [draggedCardId, setDraggedCardId] = useState(null);
	const [hoveredCategoryId, setHoveredCategoryId] = useState(null);
	const [hoveredStandalone, setHoveredStandalone] = useState(false);
	const [dragSource, setDragSource] = useState(null);
	const [collapsedCategoryIds, setCollapsedCategoryIds] = useState({});
	const hasInitializedCollapsedStateRef = useRef(false);
	const [dropFlashCategoryId, setDropFlashCategoryId] = useState(null);
	const [communityGeneralDropHighlight, setCommunityGeneralDropHighlight] = useState(false);
	const handleToggleLayoutModeRef = useRef(null);
	const dropFlashTimeoutRef = useRef(null);
	const suppressCategoryInnerPersistRef = useRef(false);
	const draggedCardIdRef = useRef(null);
	const dragSourceRef = useRef(null);
	const hoveredStandaloneRef = useRef(false);
	const categoryDragPointerRef = useRef(null);
	const standaloneDropZoneRef = useRef(null);
	const lastPointerRef = useRef({ x: 0, y: 0, timestamp: 0 });
	const generalDropHighlightRef = useRef(false);

	// Get auth user for super user check
	const authUser = useSelector((state) => state.auth);
	const isSuperUser = authUser?.role?.slug === AUTH_ROLES.SUPER;

	// Toast notification state
	const [toastNotification, setToastNotification] = useState({
		open: false,
		type: 'success',
		title: '',
		message: '',
	});

	const isOnlyHospitalDashboard = useMemo(() => {
		return isOnlyHospitalTabAccess();
	}, []);

	const percentageAgainst = useMemo(() => {
		return getDynamicPercentageBy(dbData, percentageBy, isOnlyHospitalDashboard);
	}, [percentageBy, dbData, isOnlyHospitalDashboard]);

	const isAllowReturnCard = useMemo(() => {
		if (isFullAccess()) return true;

		const selectedTab = selectedTabAccess();
		return !isOnlyHospitalOrTransfer(selectedTab);
	}, []);

	const activeFacilities = useSelector((state) => state.activeFacilities.facilities);
	const activeFacilitiesComparison = useSelector((state) => state.comparison.activeComparisonFacilitiesId);
	const facilities = useSelector((state) => state.facility); // Get all facilities for name mapping
	const triggerFilterTutorial = useFilterTutorial();
	const [isDateUpdated, setIsDateUpdated] = useState(false);
	const { facilityId: facilityIdFromHook } = useFacilityId();
	const { accountId: accountIdFromHook } = useAccountId();
	const activeFacilityLocalStorage = facilityIdFromHook;

	// Use ref to track previous facilities locally to avoid false positives on component remount
	const prevFacilitiesRef = useRef(null);
	const isInitialMountRef = useRef(true);
	const isInitialDataFetchRef = useRef(true);
	const prevIsCustomTabAddedRef = useRef(isCustomTabAdded);
	const lastMainFetchSignatureRef = useRef(null);
	const lastComparisonFetchSignatureRef = useRef(null);

	// Clear cache when facilities change
	useEffect(() => {
		// Skip on initial mount - don't clear cache when component first loads
		if (isInitialMountRef.current) {
			isInitialMountRef.current = false;
			prevFacilitiesRef.current = [...activeFacilities].sort((a, b) => {
				const aStr = String(a);
				const bStr = String(b);
				return aStr.localeCompare(bStr);
			});
			return;
		}

		// Compare current facilities with previous facilities (from ref, not Redux)
		// This ensures we only clear cache when facilities actually change during component lifecycle
		const sortedActive = [...activeFacilities].sort((a, b) => {
			const aStr = String(a);
			const bStr = String(b);
			return aStr.localeCompare(bStr);
		});
		const sortedPrev = prevFacilitiesRef.current || [];
		const facilitiesActuallyChanged = !_.isEqual(sortedActive, sortedPrev);

		if (facilitiesActuallyChanged) {
			// Facilities changed - clear all cached results
			dispatch(clearCachedResults());
		}

		// Update ref with current facilities for next comparison
		prevFacilitiesRef.current = sortedActive;
	}, [activeFacilities, dispatch]);

	const [loading, setLoading] = useState(true);
	const [loadingComparison, setLoadingComparison] = useState(false);
	const activeRequestRef = useRef(null);

	// Track if data came from cache
	const [isDataFromCache, setIsDataFromCache] = useState(false);

	// AI Chat state
	const [aiChatOpen, setAiChatOpen] = useState(false);
	const [aiChatUnreadCount, setAiChatUnreadCount] = useState(0);
	const [aiChatMinimized, setAiChatMinimized] = useState(false);
	const [aiConversationId, setAiConversationId] = useState(null);
	const [aiContextPreloaded, setAiContextPreloaded] = useState(false);
	// const [aiVectorStoreId, setAiVectorStoreId] = useState(null); // disabled: new agent API does not use vector stores

	// Check AI Chat access
	const { hasAccess: hasAiChatAccess, loading: aiChatAccessLoading } = useAiChatAccess();

	// Share Report hook
	const {
		shareReportState,
		users,
		availableIntegrations,
		handleOnClickShareReport,
		handleCloseShareReport,
		handleShareReport,
	} = useShareReport({
		downloadPdf,
		generateExcel: downloadExcel, // Pass Excel generator for chart dialogs
		reportData: {
			cardFilter,
			filter,
			dbData,
			filterListData,
		},
		pageType: PAGE_TYPE.COMMUNITY_TRANSFER,
	});

	// Helper function to generate cache key for vector store ID
	// Key includes: page type + date range + facility IDs (sorted for consistency)
	// const getVectorStoreCacheKey = useCallback(() => {
	// 	if (!filter?.startDate || !filter?.endDate || !activeFacilities?.length) {
	// 		return null;
	// 	}
	// 	const sortedFacilityIds = [...activeFacilities].sort().join(',');
	// 	return `community_transfer_vector_store_${filter.startDate}_${filter.endDate}_${sortedFacilityIds}`;
	// }, [filter?.startDate, filter?.endDate, activeFacilities]);

	// Vector store cache restore — disabled (new agent API does not use vector stores)
	/*
	useEffect(() => {
		const cacheKey = getVectorStoreCacheKey();
		if (cacheKey) {
			const cachedVectorStoreId = localStorage.getItem(cacheKey);
			if (cachedVectorStoreId) {
				setAiVectorStoreId(cachedVectorStoreId);

				// Re-register restored vector store ID for cleanup tracking
				registerVectorStoreId(cachedVectorStoreId, 'communityTransfer');
			}
		}
	}, [getVectorStoreCacheKey]);
	*/

	const getDynamicTab = useCallback(async (page) => {
		let query = { page, forType: 'transfer', forTransferType: [ADT_SUB_TYPES.AMA, ADT_SUB_TYPES.SAFE_DISCHARGE, ADT_SUB_TYPES.SNF, ADT_SUB_TYPES.TOTAL_COMMUNITY], isCustom: true };
		const res = await getQuestionsData(query);
		let dynamicCardsArr = [];
		if (res && res.length > 0) {
			const dynamicCardsExcludingDefault = res?.filter(item => (!item.isDefaultCard)) ?? [];
			dynamicCardsArr = dynamicCardsExcludingDefault?.filter(item => (!item.existingAccessor)) ?? [];
		}
		dispatch(setDynamicCards(dynamicCardsArr));
	}, [dispatch]); // Add dispatch to the dependency array

	const { updateDashboard } = useDashboard();

	// Page-specific notifications for Community Transfer page
	const {
		shareNotifications,
		showShareDialog,
		handleNotificationResponse,
		handleViewTab,
		handleCloseShareDialog
	} = usePageNotifications(PAGE_TYPE.COMMUNITY_TRANSFER);

	useEffect(() => {
		if (dbData) {
			updateDashboard({ dbData, page: PAGE_TYPE.COMMUNITY_TRANSFER, dbDataComparison, isOnlyHospitalDashboard, filter });
		}
	}, [dbData, updateDashboard, dbDataComparison, isOnlyHospitalDashboard, filter]);

	// AI Census Actions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		aiCensusActionsService.initialize(dispatch, () => ({
			common: { percentageBy },
			communityTransfer: { dbData },
			dashboardData: { isOnlyHospitalDashboard }
		}));
	}, [dispatch, percentageBy, dbData, isOnlyHospitalDashboard]);
	*/

	// AI Date Suggestions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		aiDateSuggestionsService.initialize(dispatch, () => ({}));

		const validationContext = {
			currentFilter: filter,
			censusDate: null,
			pauseDate: null,
			firstAndLastDate: null,
			activeFacilities: activeFacilities
		};

		aiDateSuggestionsService.setValidationContext(validationContext);
	}, [dispatch, filter, activeFacilities]);
	*/

	// AI Date Actions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		const validationContext = {
			currentFilter: filter,
			activeFacilities: activeFacilities
		};

		const handleFilterUpdateForAI = () => setIsDateUpdated(true);

		aiDateActionsService.initialize(validationContext, updateDashboard, handleFilterUpdateForAI);
	}, [filter, activeFacilities, updateDashboard]);
	*/

	// Vector store invalidate-on-context-change — disabled (new agent API does not use vector stores)
	/*
	useEffect(() => {
		const cacheKey = getVectorStoreCacheKey();
		const previousCacheKey = sessionStorage.getItem('community_transfer_vector_store_cache_key');

		// If context changed (date range or facilities), clear old cache and vector store
		if (previousCacheKey && previousCacheKey !== cacheKey) {
			// Clear old cached vector store ID from localStorage
			if (previousCacheKey) {
				localStorage.removeItem(previousCacheKey);
			}

			// Clear vector store ID - forces new vector store creation with fresh data
			setAiVectorStoreId(null);

			// Clear conversation ID - starts fresh conversation with new context
			setAiConversationId(null);

		}

		// Update stored cache key
		if (cacheKey) {
			sessionStorage.setItem('community_transfer_vector_store_cache_key', cacheKey);
		}
	}, [getVectorStoreCacheKey]);
	*/

	useEffect(() => {
		if (selectedAccount?._id) {
			getDynamicTab(PAGE_TYPE.COMMUNITY_TRANSFER);
		}
	}, [selectedAccount?._id, getDynamicTab]);

	// Load saved layout from database on component mount
	useEffect(() => {
		const loadLayoutFromDatabase = async () => {
			try {
				const rawLayout = await fetchSavedLayout(currentLayoutType);
				if (rawLayout != null && typeof rawLayout === "object") {
					dispatch(setCommunityTransferLayout(rawLayout));
					setCollapsedCategoryIds(getCollapsedIdsFromLayout(rawLayout, rawLayout.isFallbackToDefault));
				}
			} catch (error) {
				console.error("Error loading layout from database:", error);
				// Continue with default layout if database load fails
			}
		};

		if (shouldLoadLayoutFromDatabase(communityTransferLayout)) {
			loadLayoutFromDatabase();
		}
	}, [communityTransferLayout, dispatch, currentLayoutType, fetchSavedLayout]);

	useEffect(() => {
		if (hasInitializedCollapsedStateRef.current) return;
		if (isLayoutMode) return;
		const categories = Array.isArray(communityTransferLayout?.categories) ? communityTransferLayout.categories : [];
		if (categories.length === 0) return;
		setCollapsedCategoryIds(getCollapsedIdsFromLayout(communityTransferLayout, communityTransferLayout.isFallbackToDefault));
		hasInitializedCollapsedStateRef.current = true;
	}, [communityTransferLayout, isLayoutMode]);

	useEffect(() => {
		hoveredStandaloneRef.current = hoveredStandalone;
	}, [hoveredStandalone]);

	useEffect(() => {
		const draggingFromCategory =
			isLayoutMode &&
			(draggedCardIdRef.current || draggedCardId) &&
			dragSource &&
			dragSource !== "standalone";

		if (!draggingFromCategory) {
			generalDropHighlightRef.current = false;
			setCommunityGeneralDropHighlight(false);
			return;
		}

		const updateHighlight = (clientX, clientY) => {
			const next = pointerOverHospitalRootStandaloneArea({ x: clientX, y: clientY });
			if (next !== generalDropHighlightRef.current) {
				generalDropHighlightRef.current = next;
				setCommunityGeneralDropHighlight(next);
			}
		};

		const onMove = (e) => {
			if (e.touches?.[0]) {
				updateHighlight(e.touches[0].clientX, e.touches[0].clientY);
			} else if (typeof e.clientX === "number") {
				updateHighlight(e.clientX, e.clientY);
			}
		};

		const clear = () => {
			generalDropHighlightRef.current = false;
			setCommunityGeneralDropHighlight(false);
		};

		document.addEventListener("mousemove", onMove, true);
		document.addEventListener("touchmove", onMove, { passive: true, capture: true });
		document.addEventListener("mouseup", clear, true);
		document.addEventListener("touchend", clear, true);
		return () => {
			document.removeEventListener("mousemove", onMove, true);
			document.removeEventListener("touchmove", onMove, { capture: true });
			document.removeEventListener("mouseup", clear, true);
			document.removeEventListener("touchend", clear, true);
			clear();
		};
	}, [isLayoutMode, draggedCardId, dragSource]);

	// Pointer tracking + live category/standalone hover via geometry (shared with Hospital).
	useEffect(() => {
		if (!isLayoutMode || !draggedCardId) return;

		const resolveHoverTargets = (x, y) => {
			if (typeof x !== "number" || typeof y !== "number") return;
			const resolvedCategoryId = resolveHospitalCategoryIdUnderPointer(x, y);
			const overStandalone =
				!resolvedCategoryId && pointerOverHospitalRootStandaloneArea({ x, y });

			setHoveredCategoryId((prev) => (prev === resolvedCategoryId ? prev : resolvedCategoryId));
			setHoveredStandalone((prev) => (prev === overStandalone ? prev : overStandalone));
		};

		// While the cursor sits in the auto-scroll trigger zone (top/bottom edge),
		// skip the heavy hover resolution. This app uses React 17 (legacy
		// `ReactDOM.render`), so renders are synchronous and any state change here
		// blocks the main thread — including the auto-scroll's own rAF tick. The
		// user isn't deciding a drop target while at the edge anyway; they're
		// positioning. The drop handler re-resolves the target from the release
		// point geometrically, so dropping while still in the zone is unaffected.
		const AUTOSCROLL_ZONE_PX = 160;
		const inAutoScrollZone = (y) => {
			if (typeof y !== "number" || typeof window === "undefined") return false;
			return y < AUTOSCROLL_ZONE_PX || y > window.innerHeight - AUTOSCROLL_ZONE_PX;
		};

		const track = (e) => {
			const clientX = e.touches?.[0]?.clientX ?? e.clientX;
			const clientY = e.touches?.[0]?.clientY ?? e.clientY;
			if (typeof clientX !== "number" || typeof clientY !== "number") return;
			lastPointerRef.current = { x: clientX, y: clientY, timestamp: Date.now() };
			if (inAutoScrollZone(clientY)) return;
			resolveHoverTargets(clientX, clientY);
		};
		document.addEventListener("mousemove", track, { passive: true, capture: true });
		document.addEventListener("touchmove", track, { passive: true, capture: true });
		return () => {
			document.removeEventListener("mousemove", track, true);
			document.removeEventListener("touchmove", track, true);
		};
	}, [isLayoutMode, draggedCardId]);

	useEffect(() => {
		return () => {
			if (dropFlashTimeoutRef.current) {
				clearTimeout(dropFlashTimeoutRef.current);
			}
		};
	}, []);

	useEffect(() => {
		async function fetchMyAPI(filter, skipCache = false) {
			// Check cache synchronously before resetting locked values
			// Use the same cache key generation logic as getAllDataCount
			const mainFilterWithFacilities = { ...filter, facilityIds: activeFacilities };
			const mainCacheKey = generateCacheKey(mainFilterWithFacilities, false, 'main');

			// Skip cache check if skipCache flag is true
			const hasMainCache = skipCache ? false : !!cachedMainResults[mainCacheKey];

			// Only reset locked values if data is NOT from cache
			if (!hasMainCache) {
				batch(() => {
					dispatch(setLockTotal(null));
					dispatch(setLockedTotalBy(null));
				});
			}

			await getAllDataCount(filter, false, skipCache);
		}

		const isInitialRender = isInitialDataFetchRef.current;
		if (!skipMainFetch && isDateUpdated && filter && filter.startDate && activeFacilityLocalStorage && activeFacilities.length > 0) {
			const shouldSkipCache = !isInitialRender && prevIsCustomTabAddedRef.current !== isCustomTabAdded;
			const mainFilterWithFacilities = { ...filter, facilityIds: activeFacilities };
			const mainCacheKey = generateCacheKey(mainFilterWithFacilities, false, 'main');
			const requestSignature = `${mainCacheKey}|customTab:${String(isCustomTabAdded)}|skip:${String(
				shouldSkipCache
			)}`;

			// Guard against rerender-driven effect runs where effective fetch inputs didn't change.
			if (lastMainFetchSignatureRef.current === requestSignature) {
				return;
			}
			lastMainFetchSignatureRef.current = requestSignature;

			fetchMyAPI({ ...filter, facilityIds: activeFacilities }, shouldSkipCache);
			prevIsCustomTabAddedRef.current = isCustomTabAdded;

			// Mark that this useEffect has run at least once
			if (isInitialDataFetchRef.current) {
				isInitialDataFetchRef.current = false;
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		// eslint-disable-next-line react-hooks/exhaustive-deps
		activeFacilityLocalStorage,
		filter,
		isCustomTabAdded
	]);

	useEffect(() => {

		async function fetchMyAPI(filter) {
			// Check cache synchronously before resetting locked values
			// Use the same cache key generation logic as getAllDataCount for comparison
			const comparisonFilter = rangesSet ? {
				...filterComparison,
				facilityIds: activeFacilitiesComparison,
				startDate: comparisonRanges?.[0]?.startDate,
				endDate: comparisonRanges?.[0]?.endDate,
			} : null;
			const comparisonCacheKey = comparisonFilter ? generateCacheKey(comparisonFilter, true, 'comparison') : null;
			const hasComparisonCache = comparisonCacheKey ? !!cachedComparisonResults[comparisonCacheKey] : false;

			// Only reset locked values if comparison data is NOT from cache
			if (!hasComparisonCache) {
				batch(() => {
					dispatch(setLockTotal(null));
					dispatch(setLockedTotalBy(null));
				});
			}

			const filterData = _.omit(filter, ["defaultComparison"]);
			await getAllDataCount(filterData, true);
		}
		if (isDateUpdated && filter && filter.startDate && activeFacilityLocalStorage && activeFacilities.length > 0) {
			const comparisonFilterForSignature = rangesSet ? {
				...filterComparison,
				facilityIds: activeFacilitiesComparison,
				startDate: comparisonRanges?.[0]?.startDate,
				endDate: comparisonRanges?.[0]?.endDate,
			} : null;
			const comparisonCacheKeyForSignature = comparisonFilterForSignature
				? generateCacheKey(comparisonFilterForSignature, true, 'comparison')
				: '__no_comparison_cache_key__';
			const requestSignature = `${comparisonCacheKeyForSignature}|rangesSet:${String(
				rangesSet
			)}|start:${comparisonRanges?.[0]?.startDate || ''}|end:${comparisonRanges?.[0]?.endDate || ''}`;

			// Guard against rerender-driven effect runs where effective comparison fetch inputs didn't change.
			if (lastComparisonFetchSignatureRef.current === requestSignature) {
				return;
			}
			lastComparisonFetchSignatureRef.current = requestSignature;

			fetchMyAPI({ ...filter, facilityIds: activeFacilities });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filterComparison, comparisonRanges]);

	useEffect(() => {
		updateTotalToDBFilter(patientList);
		rangesSet && updateTotalToDBFilterComparison(patientListComparison);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [lockedTotal, projectionDays, percentageAgainst]);

	useEffect(() => {
		updateTotalToDBFilter(patientList);
		rangesSet && updateTotalToDBFilterComparison(patientListComparison);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [transferType, projectionDays]);

	useEffect(() => {
		if (isResetFilter) {
			updateTotalToDBFilter(patientList);
			dispatch(setResetFilter(false));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isResetFilter]);

	const fetchRequestRef = useRef(null);
	const fetchRequestRefComparison = useRef(null);

	// Utility function to generate cache key from filter parameters (including accountId)
	const generateCacheKey = (filterData, forComparison, type) => {
		const cleanedData = JSON.parse(
			JSON.stringify(filterData, (_key, value) => (value == null ? undefined : value))
		);

		// Sort facilityIds array to ensure consistent cache keys regardless of selection order
		// This is critical when multiple facilities are selected - same facilities in different order should generate same key
		if (cleanedData.facilityIds && Array.isArray(cleanedData.facilityIds)) {
			cleanedData.facilityIds = [...cleanedData.facilityIds].sort((a, b) => {
				const aStr = String(a);
				const bStr = String(b);
				return aStr.localeCompare(bStr);
			});
		}

		const accountId = authUser?.accountId || null;
		return JSON.stringify({ data: cleanedData, type, forComparison, accountId });
	};

	const getAllDataCount = async (filter, forComparison, skipCache = false) => {
		setFilterListData({ ...DEFAULT_COMMUNITY_DATA });
		setPatientList([]);
		setPageConverterPatientSource(null);
		setLoading(true);

		const currentRequest = uniqueId();
		if (forComparison) {
			fetchRequestRefComparison.current = currentRequest;
		} else {
			fetchRequestRef.current = currentRequest;
		}
		activeRequestRef.current = currentRequest;
		// const filterData = _.omit(filter, ["rangeFilter"]);

		try {
			// Generate cache keys - include activeFacilities to ensure unique cache per facility selection
			const mainFilterWithFacilities = { ...filter, facilityIds: activeFacilities };
			const mainCacheKey = generateCacheKey(mainFilterWithFacilities, false, 'main');
			const comparisonFilter = rangesSet ? {
				...filterComparison,
				facilityIds: activeFacilitiesComparison,
				startDate: comparisonRanges?.[0]?.startDate,
				endDate: comparisonRanges?.[0]?.endDate,
			} : null;
			const comparisonCacheKey = comparisonFilter ? generateCacheKey(comparisonFilter, true, 'comparison') : null;

			// Check cache for main result - skip cache if skipCache flag is true
			let mainResult = skipCache ? null : cachedMainResults[mainCacheKey];
			let comparisonResult = skipCache ? null : (comparisonCacheKey ? cachedComparisonResults[comparisonCacheKey] : null);

			// Track if data came from cache (both main and comparison)
			const isFromCache = !!mainResult || !!comparisonResult;
			setIsDataFromCache(isFromCache);

			// Fetch from API if not in cache
			const fetchPromises = [];

			if (!mainResult) {
				fetchPromises.push(getAllCommunicationPatient(filter, false, 'main'));
			} else {
				fetchPromises.push(Promise.resolve(mainResult));
			}

			if (rangesSet) {
				if (!comparisonResult) {
					fetchPromises.push(getAllCommunicationPatient(comparisonFilter, true, 'comparison'));
				} else {
					fetchPromises.push(Promise.resolve(comparisonResult));
				}
			} else {
				fetchPromises.push(Promise.resolve(null));
			}

			const [fetchedMainResult, fetchedComparisonResult] = await Promise.all(fetchPromises);

			// Update main result - use cached if available, otherwise use fetched and cache it
			if (!mainResult) {
				mainResult = fetchedMainResult;
				// Clear old cache before saving new cache
				dispatch(clearCachedResults('main'));
				// Save to cache
				if (mainResult) {
					dispatch(setCachedMainResult({ filterKey: mainCacheKey, result: mainResult }));
				}
			} else {
				mainResult = fetchedMainResult; // Use cached result (resolved from promise)
			}

			// Update comparison result - use cached if available, otherwise use fetched and cache it
			if (rangesSet) {
				if (!comparisonResult) {
					comparisonResult = fetchedComparisonResult;
					// Clear old cache before saving new cache
					dispatch(clearCachedResults('comparison'));
					// Save to cache
					if (comparisonResult) {
						dispatch(setCachedComparisonResult({ filterKey: comparisonCacheKey, result: comparisonResult }));
					}
				} else {
					comparisonResult = fetchedComparisonResult; // Use cached result (resolved from promise)
				}
			}

			if (activeRequestRef.current !== currentRequest) return;

			if (mainResult && mainResult.list) {
				setPatientList(mainResult);
				await updateTotalToDBFilter(mainResult);
			}

			if (comparisonResult && comparisonResult.list) {
				dispatch(setPatientListComparison(comparisonResult));
				await updateTotalToDBFilterComparison(comparisonResult);
			} else {
				dispatch(setPatientListComparison([]));
			}

		} catch (e) {
			if (activeRequestRef.current !== currentRequest) return;
			if (e?.message !== "canceled") {
				setLoading(false);

				if (communityLoading) {
					dispatch(setCommunityLoading(false));
				}
			}
		} finally {
			if (activeRequestRef.current === currentRequest) {
				setLoading(false);

				if (communityLoading) {
					dispatch(setCommunityLoading(false));
				}
			}
		}
	};

	const updateTotalToDBFilter = async (res) => {
		const latestListData = await updateFilterListData(cardFilter, res, cardFilter.priorityData, transferType, false);
		const { pageConverterFilteredPatients, ...filterListPatch } = latestListData;
		setFilterListData((prevState) => ({
			...prevState,
			...filterListPatch,
		}));
		if (Array.isArray(pageConverterFilteredPatients)) {
			setPageConverterPatientSource(pageConverterFilteredPatients);
		}
		persistCommunityPageConverterCardContext({
			pageType: PAGE_TYPE.COMMUNITY_TRANSFER,
			transferType,
			cardFilter,
			priorityData: cardFilter?.priorityData ?? [],
		});

		// Pre-load AI conversation with context data for faster responses
		await preloadAIConversation();
	};

	const updateTotalToDBFilterComparison = async (res) => {
		const latestListData = await updateFilterListData(
			cardFilterComparison,
			res,
			cardFilterComparison?.priorityData,
			transferType,
			true
		);
		const { pageConverterFilteredPatients: _omitPc, ...comparisonPatch } = latestListData;
		dispatch(setFilterListDataComparison({ ...filterListDataComparison, ...comparisonPatch }));
	};

	const handleToggle = useCallback(
		async ({
			item,
			type: typeData,
			itemComparison = null,
			setSpecialNumberFlag = true,
			isChecked,
			slidData = [],
			cardTitle = null,
			question,
			isSpacialItem = false
		}) => {
			triggerFilterTutorial();
			if (item) {
				let type = typeData;
				if (isSpacialItem) {
					type = `${type}_spacial`;
				}
				// For custom tabs (both customTab and combineTab) with duplicate titles, use composite key (accessor__uniqueKey) instead of item._id
				// This allows multiple selections of the same dashboard
				const value = question?.compositeKey || item._id;

				// For composite keys (both customTab and combineTab), get patientIds from the specific totalByPage entry using uniqueKey
				// This ensures we use the correct patientIds for each specific item, not the mutated data[0]
				// For combineTab: always has totalByPage with entries like hospital_0, admission_3, etc.
				// For customTab: may or may not have totalByPage depending on structure
				let patientIds = item?.patientIds ?? [];
				if (question?.compositeKey && question?.uniqueKey && item?.totalByPage) {
					// Get patientIds from the specific totalByPage entry for this uniqueKey
					// Works for both combineTab (always has totalByPage) and customTab (if it has totalByPage)
					const specificItem = item.totalByPage[question.uniqueKey];
					if (specificItem && specificItem.patientIds) {
						patientIds = specificItem.patientIds;
					}
				}
				// If no totalByPage or no specific entry found, patientIds already set to item?.patientIds above

				// Get patientIds from comparison data for comparison filter
				// Use itemComparison if provided, otherwise find it in filterListDataComparison
				// This works for both customTab and combineTab
				let patientIdsComparison = [];
				if (rangesSet) {
					let comparisonItem = itemComparison;

					// If itemComparison not provided, try to find it
					if (!comparisonItem && filterListDataComparison && question?.accessor) {
						// Try to find by accessor and id/_id match first
						comparisonItem = filterListDataComparison[question.accessor]?.find(
							(compItem) => compItem?.id === item?.id || compItem?._id === item?._id
						);

						// If not found by id match, try using the first item from the accessor array
						if (!comparisonItem) {
							comparisonItem = filterListDataComparison[question.accessor]?.[0];
						}
					}

					if (comparisonItem) {
						// For composite keys (both customTab and combineTab), get patientIds from the specific totalByPage entry in comparison data
						// This is the most important part - we need the specific entry's patientIds, not the main item's
						// For combineTab: always has totalByPage, so we get from specific entry
						// For customTab: if it has totalByPage, get from specific entry; otherwise use main item's patientIds
						if (question?.compositeKey && question?.uniqueKey && comparisonItem?.totalByPage) {
							const specificComparisonItem = comparisonItem.totalByPage[question.uniqueKey];
							if (specificComparisonItem && specificComparisonItem.patientIds) {
								patientIdsComparison = specificComparisonItem.patientIds;
							} else {
								// Fallback to main comparison item's patientIds if specific entry not found
								patientIdsComparison = comparisonItem?.patientIds ?? [];
							}
						} else {
							// For non-composite keys or customTab without totalByPage, use the main comparison item's patientIds
							patientIdsComparison = comparisonItem?.patientIds ?? [];
						}
					}
				}

				const filtersItem = { ...cardFilter };
				if (filtersItem[type] === undefined) {
					filtersItem[type] = [];
				}
				const filterData = filtersItem[type];

				// Check if this specific composite key is already selected
				// For composite keys, check for the composite key; for regular items, check for item._id
				let currentIndex = -1;
				if (question?.compositeKey) {
					// Check for composite key first
					currentIndex = filterData.indexOf(question.compositeKey);
					// If not found and we have an old format entry (item._id), we'll handle it below
				} else {
					// For non-composite keys, check normally
					currentIndex = filterData.indexOf(value);
				}

				let newChecked = filterData ? [...filterData] : [];
				let isRemoveIds = false;
				let isReplaceIds = false;

				if (type === "safeDischargeAssLivData") {
					if (item._id === "all") {
						if (filterData.indexOf("all") !== -1) {
							//newChecked.splice(filterData.indexOf("all"), 1);
							isRemoveIds = question?.isCustom ? true : false;
							newChecked = [];
						} else {
							let ids = _.map(slidData, "_id");
							newChecked = [...ids, "all"];
						}
					} else {
						if (filterData.indexOf("all") !== -1) {
							isRemoveIds = question?.isCustom ? true : false;
							newChecked.splice(filterData.indexOf("all"), 1);
						}
						if (currentIndex === -1) {
							// Adding new selection - push the composite key or item._id
							newChecked.push(value);
							// If we're adding a composite key and there's an old format entry (item._id), remove it
							if (question?.compositeKey) {
								const oldFormatIndex = newChecked.indexOf(item._id);
								if (oldFormatIndex !== -1) {
									newChecked.splice(oldFormatIndex, 1);
								}
							}
						} else {
							// Removing selection
							isRemoveIds = question?.isCustom ? true : false;
							newChecked.splice(currentIndex, 1);

							// For composite keys (both customTab and combineTab), when unselecting, recalculate patientIds from all remaining selected items
							if (question?.compositeKey && newChecked.length > 0) {
								const remainingPatientIds = [];
								const remainingPatientIdsComparison = [];

								// Get comparison item for recalculating comparison patientIds
								let comparisonItem = itemComparison;
								if (!comparisonItem && filterListDataComparison && question?.accessor) {
									comparisonItem = filterListDataComparison[question.accessor]?.find(
										(compItem) => compItem?.id === item?.id || compItem?._id === item?._id
									);
									if (!comparisonItem) {
										comparisonItem = filterListDataComparison[question.accessor]?.[0];
									}
								}

								newChecked.forEach(selectedKey => {
									if (selectedKey.includes('__')) {
										const [, uniqueKey] = selectedKey.split('__');

										// For main data: get from totalByPage if it exists (combineTab or customTab with totalByPage)
										if (item?.totalByPage) {
											const specificItem = item.totalByPage[uniqueKey];
											if (specificItem && specificItem.patientIds) {
												remainingPatientIds.push(...specificItem.patientIds);
											}
										} else {
											// For customTab without totalByPage, use item.patientIds
											if (item.patientIds) {
												remainingPatientIds.push(...item.patientIds);
											}
										}

										// For comparison data: get from totalByPage if it exists
										if (rangesSet && comparisonItem) {
											if (comparisonItem?.totalByPage) {
												const specificComparisonItem = comparisonItem.totalByPage[uniqueKey];
												if (specificComparisonItem && specificComparisonItem.patientIds) {
													remainingPatientIdsComparison.push(...specificComparisonItem.patientIds);
												}
											} else {
												// For customTab without totalByPage, use comparisonItem.patientIds
												if (comparisonItem.patientIds) {
													remainingPatientIdsComparison.push(...comparisonItem.patientIds);
												}
											}
										}
									} else {
										if (item.patientIds) {
											remainingPatientIds.push(...item.patientIds);
										}
										// For comparison data
										if (rangesSet && comparisonItem?.patientIds) {
											remainingPatientIdsComparison.push(...comparisonItem.patientIds);
										}
									}
								});
								patientIds = _.union(remainingPatientIds);
								if (rangesSet) {
									patientIdsComparison = _.union(remainingPatientIdsComparison);
								}
								isReplaceIds = true;
								isRemoveIds = false;
							}
						}
					}
				} else {
					if (currentIndex === -1) {
						// Adding new selection - push the composite key or item._id
						newChecked.push(value);
						// If we're adding a composite key and there's an old format entry (item._id), remove it
						if (question?.compositeKey) {
							const oldFormatIndex = newChecked.indexOf(item._id);
							if (oldFormatIndex !== -1) {
								newChecked.splice(oldFormatIndex, 1);
							}
						}
					} else {
						// Removing selection
						isRemoveIds = question?.isCustom ? true : false;
						newChecked.splice(currentIndex, 1);

						// For composite keys (both customTab and combineTab), when unselecting, recalculate patientIds from all remaining selected items
						if (question?.compositeKey && newChecked.length > 0) {
							const remainingPatientIds = [];
							const remainingPatientIdsComparison = [];

							// Get comparison item for recalculating comparison patientIds
							let comparisonItem = itemComparison;
							if (!comparisonItem && filterListDataComparison && question?.accessor) {
								comparisonItem = filterListDataComparison[question.accessor]?.find(
									(compItem) => compItem?.id === item?.id || compItem?._id === item?._id
								);
								if (!comparisonItem) {
									comparisonItem = filterListDataComparison[question.accessor]?.[0];
								}
							}

							newChecked.forEach(selectedKey => {
								if (selectedKey.includes('__')) {
									const [, uniqueKey] = selectedKey.split('__');

									// For main data: get from totalByPage if it exists (combineTab or customTab with totalByPage)
									if (item?.totalByPage) {
										const specificItem = item.totalByPage[uniqueKey];
										if (specificItem && specificItem.patientIds) {
											remainingPatientIds.push(...specificItem.patientIds);
										}
									} else {
										// For customTab without totalByPage, use item.patientIds
										if (item.patientIds) {
											remainingPatientIds.push(...item.patientIds);
										}
									}

									// For comparison data: get from totalByPage if it exists
									if (rangesSet && comparisonItem) {
										if (comparisonItem?.totalByPage) {
											const specificComparisonItem = comparisonItem.totalByPage[uniqueKey];
											if (specificComparisonItem && specificComparisonItem.patientIds) {
												remainingPatientIdsComparison.push(...specificComparisonItem.patientIds);
											}
										} else {
											// For customTab without totalByPage, use comparisonItem.patientIds
											if (comparisonItem.patientIds) {
												remainingPatientIdsComparison.push(...comparisonItem.patientIds);
											}
										}
									}
								} else {
									if (item.patientIds) {
										remainingPatientIds.push(...item.patientIds);
									}
									// For comparison data
									if (rangesSet && comparisonItem?.patientIds) {
										remainingPatientIdsComparison.push(...comparisonItem.patientIds);
									}
								}
							});
							patientIds = _.union(remainingPatientIds);
							if (rangesSet) {
								patientIdsComparison = _.union(remainingPatientIdsComparison);
							}
							isReplaceIds = true;
							isRemoveIds = false;
						}
					}
				}
				if (!isSpacialItem) {
					const [priorityData, priorityDataComparison] = await Promise.all([
						priorityFilter(
							cardFilter.priorityData,
							type,
							newChecked.length,
							cardTitle,
							question,
							patientIds,
							isRemoveIds,
							newChecked,
							isReplaceIds
						),
						rangesSet
							? priorityFilter(
								cardFilterComparison?.priorityData,
								type,
								newChecked.length,
								cardTitle,
								question,
								patientIdsComparison.length > 0 ? patientIdsComparison : patientIds,
								isRemoveIds,
								newChecked,
								isReplaceIds
							)
							: undefined,
					]);
					batch(() => {
						dispatch(setCardFilterCommunity({ [type]: newChecked, priorityData: priorityData }));
						rangesSet && dispatch(setCardFilterComparison({ [type]: newChecked, priorityData: priorityDataComparison }));

						if (specialComparisonSet && !setSpecialNumberFlag) {
							dispatch(setIsSpecialComparison(false));
						} else if (!specialComparisonSet && !setSpecialNumberFlag) {
							dispatch(setIsSpecialComparison(true));
						}
					});
					const [latestListData, latestListDataComparison] = await Promise.all([
						updateFilterListData({ ...cardFilter, [type]: newChecked }, patientList, priorityData, transferType, false),
						rangesSet
							? updateFilterListData(
								{ ...cardFilterComparison, [type]: newChecked },
								patientListComparison,
								priorityDataComparison,
								transferTypeComparison,
								true
							)
							: undefined,
					]);
					const { pageConverterFilteredPatients: mainFilteredPatients, ...mainListPatch } = latestListData;
					if (Array.isArray(mainFilteredPatients)) {
						setPageConverterPatientSource(mainFilteredPatients);
					}
					persistCommunityPageConverterCardContext({
						pageType: PAGE_TYPE.COMMUNITY_TRANSFER,
						transferType,
						cardFilter: { ...cardFilter, [type]: newChecked, priorityData },
						priorityData: priorityData ?? [],
					});
					setFilterListData((prevState) => ({
						...prevState,
						...mainListPatch,
					}));

					if (rangesSet) {
						const { pageConverterFilteredPatients: _c, ...comparisonPatch } = latestListDataComparison || {};
						const updatedFilterListData = updateCurrentFilterListData(filterListDataComparison, comparisonPatch);
						dispatch(setFilterListDataComparison(updatedFilterListData));
					}
				} else {
					batch(() => {
						const updatedFilter = { [type]: newChecked };

						dispatch(setCardFilterCommunity(updatedFilter));

						if (rangesSet) {
							dispatch(setCardFilterComparison(updatedFilter));
						}

						if (!setSpecialNumberFlag) {
							dispatch(setIsSpecialComparison(!specialComparisonSet));
						}
					});
				}
			}
		},
		[
			cardFilter,
			rangesSet,
			cardFilterComparison,
			dispatch,
			specialComparisonSet,
			patientList,
			transferType,
			patientListComparison,
			transferTypeComparison,
			filterListDataComparison,
			triggerFilterTutorial,
		]
	);

	const handleToggleAll = useCallback(async ({ items, type, cardTitle = null }) => {
		triggerFilterTutorial();
		const filtersItem = cardFilter;
		const filterData = filtersItem[type];
		const itemIds = items.map((x) => x._id);
		const valuesAlreadyInFilterData = itemIds.every((x) => filterData.includes(x));
		let newChecked = [];
		if (valuesAlreadyInFilterData) {
			newChecked = filterData.filter((x) => !itemIds.some((y) => y === x));
		} else {
			newChecked = [...filterData, ...itemIds];
		}

		const [priorityData, priorityDataComparison] = await Promise.all([
			priorityFilter(cardFilter.priorityData, type, newChecked.length, cardTitle),
			rangesSet ? priorityFilter(cardFilterComparison?.priorityData, type, newChecked.length, cardTitle) : undefined,
		]);
		dispatch(setCardFilterCommunity({ [type]: newChecked, priorityData: priorityData }));
		rangesSet && dispatch(setCardFilterComparison({ [type]: newChecked, priorityData: priorityDataComparison }));

		const [latestListData, latestListDataComparison] = await Promise.all([
			updateFilterListData({ ...cardFilter, [type]: newChecked }, patientList, priorityData, transferType, false),
			rangesSet
				? updateFilterListData(
					{ ...cardFilterComparison, [type]: newChecked },
					patientListComparison,
					priorityDataComparison,
					transferTypeComparison,
					true
				)
				: undefined,
		]);
		const { pageConverterFilteredPatients: mainFilteredPatientsAll, ...mainListPatchAll } = latestListData;
		if (Array.isArray(mainFilteredPatientsAll)) {
			setPageConverterPatientSource(mainFilteredPatientsAll);
		}
		persistCommunityPageConverterCardContext({
			pageType: PAGE_TYPE.COMMUNITY_TRANSFER,
			transferType,
			cardFilter: { ...cardFilter, [type]: newChecked, priorityData },
			priorityData: priorityData ?? [],
		});
		setFilterListData((prevState) => ({
			...prevState,
			...mainListPatchAll,
		}));

		if (rangesSet) {
			const { pageConverterFilteredPatients: _cAll, ...comparisonPatchAll } = latestListDataComparison || {};
			const updatedFilterListData = updateCurrentFilterListData(filterListDataComparison, comparisonPatchAll);
			dispatch(setFilterListDataComparison(updatedFilterListData));
		}
	}, [cardFilter, rangesSet, cardFilterComparison, dispatch, patientList, transferType, patientListComparison, transferTypeComparison, filterListDataComparison, triggerFilterTutorial]);

	// AI Filter Actions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		const onFilterApplied = () => {
			setIsDateUpdated(true);
		};

		aiFilterActionsService.initialize(
			dispatch,
			() => ({
				communityTransfer: {
					filterListData,
					cardFilter,
					dynamicCards, // Pass dynamicCards so AI can access custom/dynamic filters
					patientList   // Pass patientList so AI can access customTabs
				}
			}),
			handleToggle,
			handleToggleAll,
			onFilterApplied
		);
	}, [dispatch, filterListData, cardFilter, dynamicCards, patientList, handleToggle, handleToggleAll]);
	*/

	const handleClickTotal = useCallback(
		(total) => {
			dispatch(setTransferType(_.includes(transferType, TRANSFER_TYPE.ALL) ? [] : [TRANSFER_TYPE.ALL]));
			dispatch(setMainTotal(total));
		},
		[dispatch, transferType]
	);

	const handleClickCardTransferType = useCallback(
		(checked, type) => {
			if (type) {
				const totalSelected = transferType.length || 0;
				let newArray = [];
				if (totalSelected >= 2 && checked) {
					newArray = update(transferType, {
						$splice: [[totalSelected - 1, 1]],
					});
					newArray = update(newArray, { $push: [type] });
				} else {
					if (transferType.includes(type)) {
						newArray = update(transferType, {
							$splice: [[transferType.indexOf(type), 1]],
						});
					} else {
						newArray = update(transferType, { $push: [type] });
					}
				}
				const index = newArray.indexOf(TRANSFER_TYPE.ALL);
				if (index > -1) {
					newArray.splice(index, 1);
				}
				dispatch(setTransferType(newArray));
				dispatch(setTransferTypeComparison(newArray));
				let totalUpdated = 0;
				let totalUpdatedComparison = 0;
				if (newArray.length > 0) {
					newArray.map((ele) => {
						if (ele === "safeDischarge") {
							totalUpdated = totalUpdated + dbData.totalSafeDischarge || 0;
							totalUpdatedComparison = totalUpdated + dbDataComparison.totalSafeDischarge || 0;
						} else {
							totalUpdated = totalUpdated + dbData["total" + ele] || 0;
							totalUpdatedComparison = totalUpdatedComparison + dbDataComparison["total" + ele] || 0;
						}
					});
					dispatch(setMainTotal(totalUpdated));
					dispatch(setMainTotalComparison(totalUpdatedComparison));
				} else {
					dispatch(setMainTotal(dbData.total));
					dispatch(setMainTotalComparison(dbDataComparison?.total));
				}
			}
		},
		[transferType, dispatch, dbData, dbDataComparison]
	);

	const handleChartDialog = useCallback(
		async (title, type, relation = null, isTotalCard = false, defaultTab = null, question = null) => {
			let latestCardFilter = await updateChartFilterByPriority(cardFilter, type);
			let filterSelected =
				(cardFilter.priorityData.length > 0 && cardFilter.priorityData[0]["type"] !== type) ||
				transferType.length > 0;
			let data = [];
			if (
				type === CO_TRANSFER_CARDS_TYPE.TOTAL ||
				type === CO_TRANSFER_CARDS_TYPE.AMA ||
				type === CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE ||
				type === CO_TRANSFER_CARDS_TYPE.SNF
			) {
				data = [];
				filterSelected = false;
			} else {
				data = filterListData[type];
			}

			const { customRangeCombinedData } = processCustomRangeCombinedData(question, filterListData, type);

			// Normalize selectedFilterData for combineTab-style custom cards:
			// in the parent card, selections may be stored as composite keys like `${accessor}__hospital_0`
			// but in the details dialog we use the per-dashboard keys only (`hospital_0`, etc.)
			const rawSelectedFilterData = cardFilter[type] || [];
			const selectedFilterData =
				question?.customTab?.type === "combineTab" && Array.isArray(rawSelectedFilterData)
					? rawSelectedFilterData.map((key) => {
						if (typeof key === "string" && key.includes("__")) {
							const [, uniqueKey] = key.split("__");
							return uniqueKey || key;
						}
						return key;
					})
					: rawSelectedFilterData;

			const filters = {
				facilityId: facilityIdFromHook,
				facilityIds: activeFacilities,
				cardFilter: latestCardFilter,
				type,
				selectedFilterData,
				filter,
				relation,
				transferType,
				filterSelected,
				facilityPercentage,
				lockedByFacility,
				lockedTotal,
				isCensusTotalLocked,
				isTotalCard,
				filterListData,
				defaultTab,
				question,
				cardTitle: title,
				customRangeCombinedData,
				patientListFromPage: Array.isArray(patientList?.list) ? patientList.list : [],
			};

			dispatch(
				openDetailsDialog({
					isOpen: true,
					title,
					type,
					data: data.length > 0 ? data?.filter(item => !item?.isSpacialItem) : [],
					filters,
				})
			);

			// COMPARISON ANALOG ------>
			let latestCardFilterComparison = await updateChartFilterByPriority(cardFilterComparison, type);
			let filterSelectedComparison =
				(cardFilterComparison?.priorityData.length > 0 &&
					cardFilterComparison?.priorityData[0]["type"] !== type) ||
				transferType != null;
			let dataComparison = [];
			if (
				type === CO_TRANSFER_CARDS_TYPE.UNPLANNED ||
				type === CO_TRANSFER_CARDS_TYPE.PLANNED ||
				type === CO_TRANSFER_CARDS_TYPE.TOTAL
			) {
				filterSelectedComparison = false;
				dataComparison = [];
			} else {
				dataComparison = filterListDataComparison[type];
			}
			const { customRangeCombinedData: customRangeCombinedDataComparison } = processCustomRangeCombinedData(question, filterListDataComparison, type);

			// Normalize comparison selectedFilterData for combineTab-style custom cards in the same way
			const rawSelectedFilterDataComparison = cardFilterComparison?.[type] || [];
			const selectedFilterDataComparison =
				question?.customTab?.type === "combineTab" && Array.isArray(rawSelectedFilterDataComparison)
					? rawSelectedFilterDataComparison.map((key) => {
						if (typeof key === "string" && key.includes("__")) {
							const [, uniqueKey] = key.split("__");
							return uniqueKey || key;
						}
						return key;
					})
					: rawSelectedFilterDataComparison;

			const filtersComparison = {
				facilityId: activeFacilitiesComparison[0],
				facilityIds: activeFacilitiesComparison,
				cardFilter: latestCardFilterComparison,
				selectedFilterData: selectedFilterDataComparison,
				type,
				filter: filterComparison,
				relation,
				transferType: transferTypeComparison,
				filterSelected: filterSelectedComparison,
				facilityPercentage: facilityPercentageComparison,
				lockedByFacility: lockedByFacilityComparison,
				lockedTotal: lockedTotalComparison,
				isCensusTotalLocked: isCensusTotalLockedComparison,
				customRangeCombinedData: customRangeCombinedDataComparison
			};
			dispatch(
				openDetailsDialogComparison({
					isOpen: true,
					title,
					type,
					data: dataComparison,
					filters: filtersComparison,
				})
			);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[
			dispatch,
			filterListData,
			cardFilter,
			filter,
			filterListDataComparison,
			cardFilterComparison,
			filterComparison,
			filterListDataComparison,
		]
	);

	const getPriorityNumber = useCallback(
		(type) => {
			const idx = cardFilter.priorityData.findIndex((p) => p.type === type);
			return idx != null && idx !== -1 ? idx + 1 : null;
		},
		[cardFilter]
	);

	const handleOnClickReport = useCallback(async (type, title, isTotalCard = false, automaticallyReport = null, customData = null) => {
		try {
			if (automaticallyReport) {
				return await saveAutomaticReport({
					type,
					title,
					cardFilter,
					filter: {
						...filter,
						startDate: toSaveDate(filter.startDate),
						endDate: toSaveEndDate(filter.endDate),
					},
					dbData,
					page: PAGE_TYPE.COMMUNITY_TRANSFER,
					filterListData,
					isTotalCard,
					automaticallyReport: { ...automaticallyReport, ...customData },
					transferTypes: transferType,
					lockedByFacility: lockedByFacility?.length > 0 ? lockedByFacility?.map(item => ({ facilityId: item.facilityId, _id: item._id })) : null,
					lockedTotal,
					lockedTotalBy,
					isCensusTotalLocked,
					lastADTDate,
					percentageBy,
				});
			} else {
				await downloadPdf({
					type,
					title,
					cardFilter,
					filter,
					dbData,
					page: PAGE_TYPE.COMMUNITY_TRANSFER,
					filterListData,
					isTotalCard,
					customData
				});
			}
		} catch (error) {
			console.error("Error generating report:", error);
			dispatch({
				type: ADD_NOTIFICATION,
				payload: {
					type: "error",
					label: "Failed to generate report. Please check if popups are blocked and try again.",
					id: "reportGenerationError",
				},
			});
		}
	}, [cardFilter, filter, dbData, filterListData, transferType, lockedByFacility, lockedTotal, lockedTotalBy, isCensusTotalLocked, lastADTDate, percentageBy, saveAutomaticReport, downloadPdf, dispatch]);

	// AI Report Actions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		aiReportActionsService.initialize(
			handleOnClickReport,
			downloadExcel,
			() => ({ communityTransfer: { filterListData, cardFilter, transferType, dbData } })
		);
	}, [handleOnClickReport, downloadExcel, filterListData, cardFilter, transferType, dbData]);
	*/

	// AI Transfer Actions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		aiTransferActionsService.initialize(
			handleClickCardTransferType,
			handleClickTotal,
			() => ({ communityTransfer: { dbData, transferType } })
		);
	}, [handleClickCardTransferType, handleClickTotal, dbData, transferType]);
	*/

	// AI Dialog Actions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		aiDialogActionsService.initialize(
			handleChartDialog,
			() => ({
				communityTransfer: {
					dbData,
					transferType,
					filterListData,
					cardFilter,
					activeFacilities,
					dynamicCards,
					patientList
				}
			})
		);
	}, [handleChartDialog, dbData, transferType, filterListData, cardFilter, activeFacilities, dynamicCards, patientList]);
	*/

	const handleOnClickReportGraph = async (graphData) => {
		if (graphData && graphData.automaticallyReport) {
			const graphDataUpdated = _.omit(graphData, ["chartData", "filterData", "tableElementRef", "buildingElementRef"]);

			const reportMeta = pickObjectByPaths(graphDataUpdated?.detailsDialog, REPORT_META_PATHS);
			const filterPaths = REPORT_META_PATHS.filter((path) => path.startsWith("filters.")).map((path) => path.replace("filters.", ""));
			const graphFiltersUpdated = pickObjectByPaths(graphDataUpdated?.filters, filterPaths);

			const graphDataSanitized = {
				...graphDataUpdated,
				filters: graphFiltersUpdated,
				detailsDialog: reportMeta,
			};
			return await saveAutomaticReport({
				type: graphData?.filters?.type,
				title: graphData?.automaticallyReport?.title,
				cardFilter,
				filter: {
					...filter,
					startDate: toSaveDate(filter.startDate),
					endDate: toSaveEndDate(filter.endDate),
				},
				dbData,
				page: PAGE_TYPE.COMMUNITY_TRANSFER,
				filterListData,
				automaticallyReport: graphData?.automaticallyReport,
				transferTypes: transferType,
				lockedByFacility: lockedByFacility?.length > 0 ? lockedByFacility?.map(item => ({ facilityId: item.facilityId, _id: item._id })) : null,
				lockedTotal,
				lockedTotalBy,
				isCensusTotalLocked,
				lastADTDate,
				isGraphReport: true,
				graphData: graphDataSanitized,
				tableFilterType: graphData?.tableFilterType,
				percentageBy,
			});
		} else {
			await downloadPdf({
				type: graphData?.filters?.type,
				cardFilter,
				filter,
				dbData,
				page: PAGE_TYPE.COMMUNITY_TRANSFER,
				filterListData,
				isTotalCard: false,
				graphData,
				isGraphReport: true,
			});
		}
	};

	// Layout management functions
	const generateDefaultLayout = useCallback(() => {
		const layout = [];
		let position = 0;

		// Follow the exact same sequence as cardData
		if (_.includes(communityTransferCards, CO_TRANSFER_CARDS_TYPE.INSURANCE_DATA) || isMobile) {
			layout.push({
				id: CO_TRANSFER_CARDS_TYPE.INSURANCE_DATA,
				width: getCardWidth(CO_TRANSFER_CARDS_TYPE.INSURANCE_DATA),
				position: position++,
			});
		}

		if ((isAllowReturnCard && _.includes(communityTransferCards, CO_TRANSFER_CARDS_TYPE.RETURNS_DATA)) || isMobile) {
			layout.push({
				id: CO_TRANSFER_CARDS_TYPE.RETURNS_DATA,
				width: getCardWidth(CO_TRANSFER_CARDS_TYPE.RETURNS_DATA),
				position: position++,
			});
		}

		if (_.includes(communityTransferCards, CO_TRANSFER_CARDS_TYPE.SIXTY_DAYS_DATA) || isMobile) {
			layout.push({
				id: CO_TRANSFER_CARDS_TYPE.SIXTY_DAYS_DATA,
				width: getCardWidth(CO_TRANSFER_CARDS_TYPE.SIXTY_DAYS_DATA),
				position: position++,
			});
		}

		if (_.includes(communityTransferCards, CO_TRANSFER_CARDS_TYPE.DOCTOR_DATA) || isMobile) {
			layout.push({
				id: CO_TRANSFER_CARDS_TYPE.DOCTOR_DATA,
				width: getCardWidth(CO_TRANSFER_CARDS_TYPE.DOCTOR_DATA),
				position: position++,
			});
		}

		if (_.includes(communityTransferCards, CO_TRANSFER_CARDS_TYPE.FLOORS_DATA) || isMobile) {
			layout.push({
				id: CO_TRANSFER_CARDS_TYPE.FLOORS_DATA,
				width: getCardWidth(CO_TRANSFER_CARDS_TYPE.FLOORS_DATA),
				position: position++,
			});
		}

		if (_.includes(communityTransferCards, CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE_ASS_LIV_DATA) || isMobile) {
			layout.push({
				id: CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE_ASS_LIV_DATA,
				width: getCardWidth(CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE_ASS_LIV_DATA),
				position: position++,
			});
		}

		if (_.includes(communityTransferCards, CO_TRANSFER_CARDS_TYPE.SNF_FACILITY_DATA) || isMobile) {
			layout.push({
				id: CO_TRANSFER_CARDS_TYPE.SNF_FACILITY_DATA,
				width: getCardWidth(CO_TRANSFER_CARDS_TYPE.SNF_FACILITY_DATA),
				position: position++,
			});
		}

		// Add dynamic cards to the default layout
		if (dynamicCards?.length > 0) {
			dynamicCards.forEach((ele) => {
				if (_.includes(communityTransferCards, ele.accessor) || isMobile) {
					layout.push({
						id: getDynamicCardLayoutId(ele.accessor),
						width: 4, // Default width for dynamic cards
						position: position++,
					});
				}
			});
		}

		// Add custom tab cards to the default layout
		if (patientList?.customTabs?.length > 0) {
			patientList.customTabs.forEach((ele) => {
				if (_.includes(communityTransferCards, ele.accessor) || isMobile) {
					layout.push({
						id: getCustomTabCardLayoutId(ele.accessor),
						width: 4, // Default width for custom tab cards
						position: position++,
					});
				}
			});
		}

		return layout;
	}, [communityTransferCards, dynamicCards, patientList?.customTabs, isAllowReturnCard, isMobile]);

	const migrateLayout = useCallback((layout) => {
		if (!layout || (Array.isArray(layout) && layout.length === 0)) {
			return ensureHospitalRootOrder({
				version: "3.0",
				standalone: generateDefaultLayout().map((c) => ({ ...c, gridH: 24 })),
				categories: [],
			});
		}
		if (Array.isArray(layout)) {
			return ensureHospitalRootOrder({
				version: "3.0",
				standalone: layout.map((c) => ({ ...c, gridH: c.gridH || 24 })),
				categories: [],
			});
		}
		if (layout?.version === "2.0") {
			const generalCat = layout.categories.find((c) => c.id === "cat_general");
			const standardCategories = layout.categories.filter((c) => c.id !== "cat_general");
			return ensureHospitalRootOrder({
				version: "3.0",
				standalone: generalCat ? generalCat.cards.map((c) => ({ ...c, gridH: c.gridH || 24 })) : [],
				categories: standardCategories.map((cat) => ({
					...cat,
					gridH: cat.gridH || 94,
					cards: (cat.cards || []).map((c) => ({ ...c, gridH: c.gridH || 24 })),
				})),
			});
		}
		const categories = layout.categories || [];
		const standalone = layout.standalone || [];
		const hasCategoryWithCards = categories.some(
			(cat) => Array.isArray(cat.cards) && cat.cards.length > 0
		);
		if (!hasCategoryWithCards) {
			const merged = [];
			const seen = new Set();
			const pushCard = (c) => {
				if (c && c.id != null && !seen.has(c.id)) {
					seen.add(c.id);
					merged.push({ ...c, gridH: c.gridH || 24 });
				}
			};
			standalone.forEach(pushCard);
			categories.forEach((cat) => (cat.cards || []).forEach(pushCard));
			if (merged.length === 0) {
				return ensureHospitalRootOrder({
					version: "3.0",
					standalone: generateDefaultLayout().map((c) => ({ ...c, gridH: 24 })),
					categories: [],
				});
			}
			return ensureHospitalRootOrder({
				...layout,
				version: layout.version || "3.0",
				categories: [],
				standalone: merged,
				rootOrder: undefined,
			});
		}
		return ensureHospitalRootOrder(layout);
	}, [generateDefaultLayout]);

	const patchCommunityTransferLayoutBase = useCallback(
		(base) => {
			if (!base) return base;
			const normalized = normalizeCommunityTransferLayoutCardIds(base, dynamicCards, patientList?.customTabs);
			return augmentCommunityTransferLayoutWithSelectedCards(
				normalized,
				communityTransferCards,
				dynamicCards,
				patientList?.customTabs
			);
		},
		[communityTransferCards, dynamicCards, patientList?.customTabs]
	);

	const isV3LayoutActive = useMemo(() => {
		if (isLayoutMode && tempLayout && typeof tempLayout === "object" && !Array.isArray(tempLayout) && tempLayout.version) {
			return true;
		}
		if (!isLayoutMode && isStoredLayoutV3(communityTransferLayout)) {
			return true;
		}
		return false;
	}, [isLayoutMode, tempLayout, communityTransferLayout]);

	const getLegacyFlatLayout = useCallback(() => {
		if (isLayoutMode) {
			return Array.isArray(tempLayout) && tempLayout.length > 0 ? tempLayout : generateDefaultLayout();
		}
		if (Array.isArray(communityTransferLayout) && communityTransferLayout.length > 0) {
			return communityTransferLayout;
		}
		return generateDefaultLayout();
	}, [tempLayout, communityTransferLayout, isLayoutMode, generateDefaultLayout]);

	const getCurrentLayoutV3 = useCallback(() => {
		const base = isLayoutMode && tempLayout?.version ? tempLayout : migrateLayout(communityTransferLayout);
		const patched = patchCommunityTransferLayoutBase(base);
		return ensureHospitalRootOrder({
			version: patched?.version || "3.0",
			standalone: patched?.standalone || [],
			categories: patched?.categories || [],
			rootOrder: patched?.rootOrder,
		});
	}, [tempLayout, communityTransferLayout, isLayoutMode, migrateLayout, patchCommunityTransferLayoutBase]);

	const communityTransferHeaderPopoverDynamicCards = useMemo(
		() => [...(dynamicCards || []), ...(patientList?.customTabs || [])],
		[dynamicCards, patientList?.customTabs]
	);

	const communityTransferDynamicTabDataByAccessor = useMemo(() => {
		const out = {};
		const layout = getCurrentLayoutV3();
		const visit = (cards) => {
			if (!Array.isArray(cards)) return;
			for (const card of cards) {
				if (card?.component === "dynamic" && card?.data?.accessor != null) {
					out[card.data.accessor] = card.data;
				}
			}
		};
		visit(layout?.standalone);
		for (const cat of layout?.categories || []) {
			visit(cat?.cards);
		}
		return out;
	}, [getCurrentLayoutV3]);

	const communityTransferHeaderCardFilterPanelProps = useMemo(
		() => ({
			handleToggle,
			handleToggleAll,
			filterListData,
			filterListDataComparison,
			cardFilter,
			filter,
			filterComparison,
			loading,
			loadingComparison,
			projectionDays,
			filterTotal,
			filterTotalComparison,
			dbData,
			dbDataComparison,
			specialComparisonSet,
			transferType,
			lockedTotalBy,
			getPriorityNumber,
			comparingAgainstDifferentFacility,
			dynamicCards: communityTransferHeaderPopoverDynamicCards,
			communityTransferDynamicTabDataByAccessor,
			percentageAgainst,
		}),
		[
			handleToggle,
			handleToggleAll,
			filterListData,
			filterListDataComparison,
			cardFilter,
			filter,
			filterComparison,
			loading,
			loadingComparison,
			projectionDays,
			filterTotal,
			filterTotalComparison,
			dbData,
			dbDataComparison,
			specialComparisonSet,
			transferType,
			lockedTotalBy,
			getPriorityNumber,
			comparingAgainstDifferentFacility,
			communityTransferHeaderPopoverDynamicCards,
			communityTransferDynamicTabDataByAccessor,
			percentageAgainst,
		]
	);

	const renderCommunityTransferCardFilterPopover = useCallback(
		({ dataKey, headerFilterPopoverOpen }) => (
			<CommunityTransferHeaderCardFilterPanel
				dataKey={dataKey}
				headerFilterPopoverOpen={headerFilterPopoverOpen}
				{...communityTransferHeaderCardFilterPanelProps}
			/>
		),
		[communityTransferHeaderCardFilterPanelProps]
	);

	const handleSaveLayout = useCallback(async (options = {}) => {
		const { skipExitAfterSave = false, saveForBothLayouts = false } = options;
		try {
			let layoutToSave;
			if (isV3LayoutActive) {
				layoutToSave = applyCollapsedStateToLayout(
					ensureHospitalRootOrder(
						patchCommunityTransferLayoutBase(
							tempLayout?.version ? tempLayout : migrateLayout(communityTransferLayout)
						)
					),
					collapsedCategoryIds
				);
				const emptyCategory = (layoutToSave.categories || []).find(
					(cat) => !cat.cards || cat.cards.length === 0
				);
				if (emptyCategory) {
					dispatch({
						type: ADD_NOTIFICATION,
						payload: {
							label: "A category must contain at least one item.",
							type: "error",
							id: "emptyCategoryCommunityTransfer",
						},
					});
					return false;
				}
			} else {
				layoutToSave =
					Array.isArray(tempLayout) && tempLayout.length > 0 ? tempLayout : generateDefaultLayout();
			}

			await saveLayoutToDatabase(
				{
					page: PAGE_TYPE.COMMUNITY_TRANSFER,
					layout: layoutToSave,
					cards: communityTransferCards,
					timestamp: new Date().toISOString(),
				},
				currentLayoutType
			);
			if (saveForBothLayouts) {
				const mirrorLayoutType = currentLayoutType === "default" ? "personal" : "default";
				await saveLayoutToDatabase(
					{
						page: PAGE_TYPE.COMMUNITY_TRANSFER,
						layout: layoutToSave,
						cards: communityTransferCards,
						timestamp: new Date().toISOString(),
					},
					mirrorLayoutType
				);
			}

			dispatch(setCommunityTransferLayout(layoutToSave));
			setHasLayoutChanges(false);

			const layoutTypeText = saveForBothLayouts
				? "default and personal"
				: currentLayoutType === "default"
					? "default"
					: "personal";
			dispatch({
				type: ADD_NOTIFICATION,
				payload: {
					label: `Your ${layoutTypeText} layout has been saved successfully.`,
					type: "success",
					id: "savedCustomLayoutCommunityTransfer",
				},
			});
			if (!skipExitAfterSave) {
				handleToggleLayoutModeRef.current?.(true);
			}
			return true;
		} catch (error) {
			dispatch({
				type: ADD_NOTIFICATION,
				payload: {
					label: "Failed to save layout. Please try again.",
					type: "error",
					id: "saveFailedCommunityTransfer",
				},
			});
			return false;
		}
	}, [
		isV3LayoutActive,
		tempLayout,
		migrateLayout,
		communityTransferLayout,
		communityTransferCards,
		currentLayoutType,
		dispatch,
		patchCommunityTransferLayoutBase,
		generateDefaultLayout,
		collapsedCategoryIds,
	]);

	const handleLayoutTypeChange = useCallback(
		async (layoutType) => {
			try {
				setLayoutTypeLoading(true);
				setCurrentLayoutType(layoutType);
				const rawLayout = await fetchLayoutByType(layoutType);
				if (rawLayout != null && typeof rawLayout === "object") {
					if (Array.isArray(rawLayout)) {
						dispatch(setCommunityTransferLayout(rawLayout));
						setCollapsedCategoryIds({});
						setTempLayout(rawLayout);
					} else {
						const nestedLayout = ensureHospitalRootOrder(
							patchCommunityTransferLayoutBase(migrateLayout(rawLayout))
						);
						dispatch(setCommunityTransferLayout(nestedLayout));
						setCollapsedCategoryIds(getCollapsedIdsFromLayout(nestedLayout, false));
						setTempLayout(nestedLayout);
					}
				} else {
					const defaultLayout = generateDefaultLayout();
					dispatch(setCommunityTransferLayout(defaultLayout));
					setCollapsedCategoryIds({});
					setTempLayout(defaultLayout);
				}

				setHasLayoutChanges(false);
				dispatch(setIsLayoutMode(true));
			} catch (error) {
				console.error("Error switching layout type:", error);
				const defaultLayout = generateDefaultLayout();
				dispatch(setCommunityTransferLayout(defaultLayout));
				setTempLayout(defaultLayout);
				dispatch(setIsLayoutMode(true));
			} finally {
				setTimeout(() => {
					setLayoutTypeLoading(false);
				}, 500);
			}
		},
		[dispatch, migrateLayout, patchCommunityTransferLayoutBase, generateDefaultLayout, fetchLayoutByType]
	);

	const handleToggleLayoutMode = useCallback(
		async (isSkipSave = false) => {
			if (isLayoutMode) {
				if (hasLayoutChanges && !isSkipSave) {
					const saved = await handleSaveLayout({ skipExitAfterSave: true });
					if (!saved) {
						return;
					}
				}

				if (isSuperUser && currentLayoutType === "default") {
					try {
						const rawLayout = await fetchLayoutByType("personal");
						if (rawLayout != null && typeof rawLayout === "object") {
							const normalizedLayout = ensureHospitalRootOrder(
								patchCommunityTransferLayoutBase(migrateLayout(rawLayout))
							);
							dispatch(setCommunityTransferLayout(normalizedLayout));
							setCollapsedCategoryIds(getCollapsedIdsFromLayout(normalizedLayout, false));
							setCurrentLayoutType("personal");
						} else {
							const defaultLayout = generateDefaultLayout();
							dispatch(setCommunityTransferLayout(defaultLayout));
							setCollapsedCategoryIds({});
							setCurrentLayoutType("personal");
						}
					} catch (error) {
						console.error("Error switching back to personal layout:", error);
						const defaultLayout = generateDefaultLayout();
						dispatch(setCommunityTransferLayout(defaultLayout));
						setCollapsedCategoryIds({});
						setCurrentLayoutType("personal");
					}
				}

				dispatch(setIsLayoutMode(false));
				setHasLayoutChanges(false);
				setTempLayout(
					(tempLayout &&
						typeof tempLayout === "object" &&
						!Array.isArray(tempLayout) &&
						tempLayout.version) ||
						isStoredLayoutV3(communityTransferLayout)
						? {}
						: []
				);
			} else {
				dispatch(setIsLayoutMode(true));
				if (isStoredLayoutV3(communityTransferLayout)) {
					setTempLayout(
						ensureHospitalRootOrder(
							patchCommunityTransferLayoutBase(migrateLayout(communityTransferLayout))
						)
					);
				} else {
					const cur =
						Array.isArray(communityTransferLayout) && communityTransferLayout.length > 0
							? communityTransferLayout
							: generateDefaultLayout();
					setTempLayout(cur);
				}
			}
		},
		[
			isLayoutMode,
			hasLayoutChanges,
			communityTransferLayout,
			generateDefaultLayout,
			currentLayoutType,
			dispatch,
			isSuperUser,
			migrateLayout,
			handleSaveLayout,
			patchCommunityTransferLayoutBase,
			tempLayout,
			fetchLayoutByType,
		]
	);

	handleToggleLayoutModeRef.current = handleToggleLayoutMode;

	const handleLayoutChangeInCategory = useCallback(
		(categoryId, newCards) => {
			const currentLayout = getCurrentLayoutV3();
			const updatedCategories = currentLayout.categories.map((cat) => {
				if (cat.id === categoryId) {
					return { ...cat, cards: newCards };
				}
				return cat;
			});
			setTempLayout(ensureHospitalRootOrder({ ...currentLayout, categories: updatedCategories }));
			setHasLayoutChanges(true);
		},
		[getCurrentLayoutV3]
	);

	const scrollToCategory = useCallback((categoryId) => {
		let attempts = 0;
		const maxAttempts = 20;
		const tryScroll = () => {
			const el = document.querySelector(`[data-category-id="${categoryId}"]`);
			if (el) {
				el.scrollIntoView({ behavior: "smooth", block: "center" });
				return;
			}
			if (attempts < maxAttempts) {
				attempts += 1;
				requestAnimationFrame(tryScroll);
			}
		};
		requestAnimationFrame(tryScroll);
	}, []);

	const handleCreateCategory = useCallback(() => {
		let base;
		if (isLayoutMode && tempLayout && typeof tempLayout === "object" && !Array.isArray(tempLayout) && tempLayout.version) {
			base = getCurrentLayoutV3();
		} else if (Array.isArray(tempLayout) && tempLayout.length > 0) {
			base = migrateLayout(tempLayout);
		} else if (Array.isArray(communityTransferLayout) && communityTransferLayout.length > 0) {
			base = migrateLayout(communityTransferLayout);
		} else {
			base = migrateLayout(generateDefaultLayout());
		}
		const newCategory = {
			id: `category_${Date.now()}`,
			title: "New Category",
			cards: [],
		};
		setTempLayout(
			ensureHospitalRootOrder({
				...base,
				categories: [...(base.categories || []), newCategory],
			})
		);
		setHasLayoutChanges(true);
		scrollToCategory(newCategory.id);
	}, [getCurrentLayoutV3, migrateLayout, communityTransferLayout, tempLayout, isLayoutMode, generateDefaultLayout, scrollToCategory]);

	const handleAddCategoryFromMenu = useAddCategoryFromMenu({
		pageLabel: "Community transfer",
		fetchLayoutByType,
		getCurrentLayout: getCurrentLayoutV3,
		patchLayoutBase: patchCommunityTransferLayoutBase,
		migrateLayout,
		dispatch,
		setPageLayout: setCommunityTransferLayout,
		setLayoutTypeLoading,
		setCurrentLayoutType,
		setTempLayout,
		setHasLayoutChanges,
		scrollToCategory,
	});

	const handleUpdateCategoryTitle = useCallback(
		(id, newTitle) => {
			const currentLayout = getCurrentLayoutV3();
			const updatedCategories = currentLayout.categories.map((cat) => {
				if (cat.id === id) {
					return { ...cat, title: newTitle };
				}
				return cat;
			});
			setTempLayout(ensureHospitalRootOrder({ ...currentLayout, categories: updatedCategories }));
			setHasLayoutChanges(true);
		},
		[getCurrentLayoutV3]
	);

	const handleDeleteCategory = useCallback(
		(id) => {
			const currentLayout = getCurrentLayoutV3();
			const categoryToDelete = currentLayout.categories.find((cat) => cat.id === id);
			const cardsToMove = categoryToDelete?.cards || [];

			const updatedCategories = currentLayout.categories.filter((cat) => cat.id !== id);
			const standaloneIds = new Set((currentLayout.standalone || []).map((c) => c.id));
			const cardsToAppend = cardsToMove.filter((c) => !standaloneIds.has(c.id));
			const updatedStandalone = [...(currentLayout.standalone || []), ...cardsToAppend];

			setTempLayout(
				ensureHospitalRootOrder({
					...currentLayout,
					standalone: updatedStandalone,
					categories: updatedCategories,
				})
			);
			setHasLayoutChanges(true);
		},
		[getCurrentLayoutV3]
	);

	const handleRootGapDrop = useCallback(
		(cardId, rootOrderIndex, _e, dragType) => {
			if (!cardId || typeof rootOrderIndex !== "number") return;
			const currentLayout = getCurrentLayoutV3();

			const isCategoryDrag =
				dragType === "category"
				|| currentLayout.categories.some((c) => c.id === cardId);
			if (isCategoryDrag) {
				const rootOrder = currentLayout.rootOrder || [];
				const fromIdx = rootOrder.findIndex((e) => e.id === cardId);
				if (fromIdx === -1) return;
				const targetIdx = Math.min(rootOrderIndex, rootOrder.length);
				const nextRootOrder = [...rootOrder];
				const [moved] = nextRootOrder.splice(fromIdx, 1);
				const adjusted = targetIdx > fromIdx ? targetIdx - 1 : targetIdx;
				nextRootOrder.splice(adjusted, 0, moved);
				const renumbered = nextRootOrder.map((e, i) => ({ ...e, position: i }));
				setTempLayout(
					ensureHospitalRootOrder({ ...currentLayout, rootOrder: renumbered })
				);
				setHasLayoutChanges(true);
				draggedCardIdRef.current = null;
				dragSourceRef.current = null;
				setTimeout(() => {
					setDraggedCardId(null);
					setHoveredCategoryId(null);
					setHoveredStandalone(false);
					setDragSource(null);
				}, 50);
				return;
			}

			// If the card is leaving its category and that was the last card, the
			// category becomes empty — drop it, matching the behavior of
			// `handleMoveCardToCategory`.
			const sourceCat = currentLayout.categories.find((cat) =>
				cat.cards.some((c) => c.id === cardId)
			);
			const removeEmptySourceCategoryId =
				sourceCat && sourceCat.cards.length === 1 ? sourceCat.id : null;

			let next = computeLayoutAfterRootGapInsert(currentLayout, cardId, rootOrderIndex);
			if (!next) return;

			if (removeEmptySourceCategoryId) {
				next = {
					...next,
					categories: next.categories.filter((c) => c.id !== removeEmptySourceCategoryId),
					rootOrder: (next.rootOrder || []).filter(
						(e) => e.id !== removeEmptySourceCategoryId
					),
				};
			}

			setTempLayout(ensureHospitalRootOrder(next));
			setHasLayoutChanges(true);

			// CRITICAL: clear the drag refs synchronously. After this drop event,
			// the source cell's `dragend` still fires and walks the category-source
			// `onDragStop` chain — that chain sees the release point over root area
			// (a gap has no `[data-category-id]` ancestor), classifies it as a
			// standalone drop, and calls `handleCardDrop("standalone", ...)`. That
			// would overwrite the gap-targeted insert with a plain append. Nulling
			// `draggedCardIdRef.current` here makes `handleCardDrop` early-return at
			// its `if (!activeId) return;` guard, so the gap insert wins.
			draggedCardIdRef.current = null;
			dragSourceRef.current = null;
			suppressCategoryInnerPersistRef.current = true;
			setTimeout(() => {
				setDraggedCardId(null);
				setHoveredCategoryId(null);
				setHoveredStandalone(false);
				setDragSource(null);
			}, 50);
			queueMicrotask(() => {
				suppressCategoryInnerPersistRef.current = false;
			});
		},
		[getCurrentLayoutV3]
	);

	const handleCardDropAtCategoryEdge = useCallback(
		(cardId, position, targetCategoryId) => {
			if (!cardId || !targetCategoryId) return;
			const layoutNow = getCurrentLayoutV3();
			const targetCat = layoutNow.categories.find((c) => c.id === targetCategoryId);
			if (!targetCat) return;
			// Filter out the moved card from the destination's existing cards so
			// we resolve the right "first card" when reordering within the same
			// category — otherwise dropping the first card on the start gap would
			// `insertBeforeId` itself and yield a no-op.
			const others = (targetCat.cards || []).filter((c) => c.id !== cardId);
			const insertBeforeId =
				position === 'start' && others.length > 0 ? others[0].id : null;
			handleMoveCardToCategory(cardId, targetCategoryId, {
				categoryInsertBeforeId: insertBeforeId,
			});
			// Same reasoning as `handleRootGapDrop`: clear refs synchronously so
			// the source's `onDragStop` chain (which fires after this drop event)
			// early-returns at `if (!activeId) return;` instead of re-applying a
			// generic standalone/category drop on top of our edge insert.
			draggedCardIdRef.current = null;
			dragSourceRef.current = null;
			suppressCategoryInnerPersistRef.current = true;
			setTimeout(() => {
				setDraggedCardId(null);
				setHoveredCategoryId(null);
				setHoveredStandalone(false);
				setDragSource(null);
			}, 50);
			queueMicrotask(() => {
				suppressCategoryInnerPersistRef.current = false;
			});
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[getCurrentLayoutV3]
	);

	const handleMoveCardToCategory = useCallback(
		(cardId, toCategoryId, moveOptions) => {
			const currentLayout = getCurrentLayoutV3();
			const normalizedTarget =
				toCategoryId === "standalone" || !toCategoryId ? "standalone" : toCategoryId;

			const sourceCat = currentLayout.categories.find((cat) =>
				cat.cards.some((c) => c.id === cardId)
			);
			const leavingCategory =
				sourceCat &&
				(normalizedTarget === "standalone" || normalizedTarget !== sourceCat.id);
			const removeEmptySourceCategoryId =
				sourceCat && sourceCat.cards.length === 1 && leavingCategory ? sourceCat.id : null;

			let next = computeLayoutAfterCardMove(
				currentLayout,
				cardId,
				normalizedTarget,
				moveOptions || {}
			);
			if (!next) return "noop";

			if (removeEmptySourceCategoryId) {
				next = {
					...next,
					categories: next.categories.filter((c) => c.id !== removeEmptySourceCategoryId),
				};
			}

			setTempLayout(ensureHospitalRootOrder(next));
			setHasLayoutChanges(true);
			return removeEmptySourceCategoryId ? "done_removed_empty_category" : "done";
		},
		[getCurrentLayoutV3]
	);

	const handleRootGridChange = useCallback(
		(orderedItems) => {
			const current = getCurrentLayoutV3();
			const catIds = new Set(current.categories.map((c) => c.id));
			const rootOrder = orderedItems.map((it, i) => ({
				id: it.id,
				type: catIds.has(it.id) ? "category" : "card",
				width: catIds.has(it.id) ? 12 : it.width || 4,
				position: i,
			}));
			setTempLayout(
				ensureHospitalRootOrder({
					...current,
					rootOrder,
				})
			);
			setHasLayoutChanges(true);
		},
		[getCurrentLayoutV3]
	);

	const handleCardDrop = useCallback(
		(targetId, targetTitle = "General Cards", dropEvent) => {
			const activeId = draggedCardIdRef.current;
			if (!activeId) return;

			const activeSource = dragSourceRef.current;

			if (activeSource === targetId) {
				draggedCardIdRef.current = null;
				dragSourceRef.current = null;
				setDraggedCardId(null);
				setHoveredCategoryId(null);
				setHoveredStandalone(false);
				setDragSource(null);
				return;
			}

			const isStandaloneTarget = targetId === "standalone" || !targetId;
			const pt =
				getPointerClientCoords(dropEvent) ||
				categoryDragPointerRef.current ||
				(Date.now() - lastPointerRef.current.timestamp < 500
					? lastPointerRef.current
					: null);
			const standaloneInsertBeforeId = isStandaloneTarget
				? getStandaloneInsertBeforeIdFromPoint(pt, activeId)
				: null;
			const categoryInsertTarget =
				!isStandaloneTarget && pt
					? getCategoryInsertBeforeTargetFromPoint(pt, activeId, {
						categoryId: targetId,
					})
					: null;
			const categoryInsertBeforeId =
				categoryInsertTarget && categoryInsertTarget.categoryId === targetId
					? categoryInsertTarget.insertBeforeId
					: null;

			const result = handleMoveCardToCategory(activeId, targetId, {
				...(isStandaloneTarget
					? { standaloneInsertBeforeId }
					: { categoryInsertBeforeId }),
			});
			draggedCardIdRef.current = null;
			dragSourceRef.current = null;
			setDraggedCardId(null);
			setHoveredCategoryId(null);
			setHoveredStandalone(false);
			setDragSource(null);

			if (result === "done" || result === "done_removed_empty_category") {


				if (targetId && targetId !== "standalone") {
					if (dropFlashTimeoutRef.current) {
						clearTimeout(dropFlashTimeoutRef.current);
					}
					setDropFlashCategoryId(targetId);
					dropFlashTimeoutRef.current = setTimeout(() => {
						setDropFlashCategoryId(null);
						dropFlashTimeoutRef.current = null;
					}, 750);
				}
			}
		},
		[handleMoveCardToCategory]
	);

	const handleLayoutChange = useCallback((newLayout) => {
		setTempLayout(newLayout);
		setHasLayoutChanges(true);
	}, []);

	const handleResetLayout = useCallback(async () => {
		try {
			const rawLayout = await fetchDefaultLayout();
			if (rawLayout != null && typeof rawLayout === "object") {
				if (Array.isArray(rawLayout)) {
					setTempLayout(rawLayout);
				} else {
					setTempLayout(migrateLayout(rawLayout));
				}
				setHasLayoutChanges(true);
			} else {
				const defaultLayout = generateDefaultLayout();
				setTempLayout(defaultLayout);
				setHasLayoutChanges(true);
			}
		} catch (error) {
			console.error("Error resetting layout:", error);
			const defaultLayout = generateDefaultLayout();
			setTempLayout(defaultLayout);
			setHasLayoutChanges(true);
		}
	}, [generateDefaultLayout, migrateLayout, fetchDefaultLayout]);

	// Prepare card data for drag-and-drop layout
	const cardData = useMemo(() => {
		const cards = [];

		// Only include cards that are actually selected/visible
		if (_.includes(communityTransferCards, CO_TRANSFER_CARDS_TYPE.INSURANCE_DATA)) {
			cards.push({
				id: CO_TRANSFER_CARDS_TYPE.INSURANCE_DATA,
				width: getCardWidth(CO_TRANSFER_CARDS_TYPE.INSURANCE_DATA),
				component: 'insurance'
			});
		}

		if (isAllowReturnCard && _.includes(communityTransferCards, CO_TRANSFER_CARDS_TYPE.RETURNS_DATA)) {
			cards.push({
				id: CO_TRANSFER_CARDS_TYPE.RETURNS_DATA,
				width: getCardWidth(CO_TRANSFER_CARDS_TYPE.RETURNS_DATA),
				component: 'returns'
			});
		}

		if (_.includes(communityTransferCards, CO_TRANSFER_CARDS_TYPE.SIXTY_DAYS_DATA)) {
			cards.push({
				id: CO_TRANSFER_CARDS_TYPE.SIXTY_DAYS_DATA,
				width: getCardWidth(CO_TRANSFER_CARDS_TYPE.SIXTY_DAYS_DATA),
				component: 'sixtyDays'
			});
		}

		if (_.includes(communityTransferCards, CO_TRANSFER_CARDS_TYPE.DOCTOR_DATA)) {
			cards.push({
				id: CO_TRANSFER_CARDS_TYPE.DOCTOR_DATA,
				width: getCardWidth(CO_TRANSFER_CARDS_TYPE.DOCTOR_DATA),
				component: 'doctor'
			});
		}

		if (_.includes(communityTransferCards, CO_TRANSFER_CARDS_TYPE.DAYS_DATA)) {
			cards.push({
				id: CO_TRANSFER_CARDS_TYPE.DAYS_DATA,
				width: getCardWidth(CO_TRANSFER_CARDS_TYPE.DAYS_DATA),
				component: 'days'
			});
		}

		if (_.includes(communityTransferCards, CO_TRANSFER_CARDS_TYPE.FLOORS_DATA)) {
			cards.push({
				id: CO_TRANSFER_CARDS_TYPE.FLOORS_DATA,
				width: getCardWidth(CO_TRANSFER_CARDS_TYPE.FLOORS_DATA),
				component: 'floors'
			});
		}

		if (_.includes(communityTransferCards, CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE_ASS_LIV_DATA)) {
			cards.push({
				id: CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE_ASS_LIV_DATA,
				width: getCardWidth(CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE_ASS_LIV_DATA),
				component: 'safeDischargeAssLiv'
			});
		}

		if (_.includes(communityTransferCards, CO_TRANSFER_CARDS_TYPE.SNF_FACILITY_DATA)) {
			cards.push({
				id: CO_TRANSFER_CARDS_TYPE.SNF_FACILITY_DATA,
				width: getCardWidth(CO_TRANSFER_CARDS_TYPE.SNF_FACILITY_DATA),
				component: 'snfFacility'
			});
		}

		// Add dynamic cards to the drag-and-drop system
		if (dynamicCards?.length > 0) {
			dynamicCards.forEach((ele) => {
				if (_.includes(communityTransferCards, ele.accessor)) {
					const row = COMMUNITY_CUSTOM_CARD_DATA.find((r) => r.value === ele?.accessor && !r.isCustomTab);
					cards.push({
						id: getDynamicCardLayoutId(ele.accessor),
						width: 4, // Default width for dynamic cards (lg=4)
						component: 'dynamic',
						data: {
							...ele,
							isCustomTab: false,
							...(row && {
								_id: row._id || ele?._id,
								shareCount: row.shareCount ?? ele.shareCount,
								isUniversalAccess: row.isUniversalAccess ?? ele.isUniversalAccess,
								isUniversal: row.isUniversal ?? ele.isUniversal,
								isShared: row.isShared ?? ele.isShared,
								isCustomShare: row.isCustomShare ?? ele.isCustomShare,
								shareInfo: row.shareInfo ?? ele.shareInfo,
								sharedBy: row.sharedBy ?? ele.sharedBy,
								sharedByName: row.sharedByName ?? ele.sharedByName,
								shareId: row.shareId ?? ele.shareId,
							}),
						},
					});
				}
			});
		}

		// Add custom tab cards to the drag-and-drop system
		if (patientList?.customTabs?.length > 0) {
			patientList.customTabs.forEach((ele) => {
				if (_.includes(communityTransferCards, ele.accessor)) {
					cards.push({
						id: getCustomTabCardLayoutId(ele.accessor),
						width: 4, // Default width for custom tab cards (lg=4)
						component: 'dynamic',
						data: { ...ele, isCustomTab: true }
					});
				}
			});
		}

		return cards;
	}, [communityTransferCards, isAllowReturnCard, dynamicCards, patientList?.customTabs, COMMUNITY_CUSTOM_CARD_DATA]);

	const communityMainGridPayload = useMemo(() => {
		const lo = getCurrentLayoutV3();
		const rootOrder = lo.rootOrder || [];
		const layoutForDrag = [];
		const cardsForGrid = [];
		rootOrder.forEach((entry) => {
			if (entry.type === "category") {
				const cat = lo.categories.find((c) => c.id === entry.id);
				if (!cat) return;
				const visibleCategoryCards = (cat.cards || [])
					.map((cardItem) => cardData.find((c) => c.id === cardItem.id))
					.filter(Boolean);
				if (!isLayoutMode && visibleCategoryCards.length === 0) return;
				const categoryForSizing = !isLayoutMode
					? { ...cat, cards: visibleCategoryCards }
					: cat;
				const isCollapsed = !isLayoutMode && Boolean(collapsedCategoryIds[entry.id]);
				const gridH = isCollapsed
					? 3
					: estimateCategoryGridRowUnits(categoryForSizing, cardData, {
						compactTwoCol: categoryInnerTwoCol,
					});
				const pos = layoutForDrag.length;
				layoutForDrag.push({
					id: entry.id,
					type: entry.type,
					width: entry.width,
					position: pos,
					title: entry.title,
				});
				cardsForGrid.push({
					id: entry.id,
					type: "category",
					width: 12,
					gridH,
				});
				return;
			}
			const def = cardData.find((c) => c.id === entry.id);
			if (!def?.component) return;
			const s = lo.standalone.find((c) => c.id === entry.id);
			const pos = layoutForDrag.length;
			layoutForDrag.push({
				id: entry.id,
				type: entry.type,
				width: entry.width,
				position: pos,
				title: entry.title,
			});
			cardsForGrid.push({
				...def,
				...s,
				id: entry.id,
				type: "card",
				width: s?.width ?? def?.width ?? 4,
				gridH: 24,
			});
		});
		return { layoutForDrag, cardsForGrid };
	}, [getCurrentLayoutV3, cardData, isLayoutMode, collapsedCategoryIds, categoryInnerTwoCol]);

	const persistCollapsedCategories = useCollapsedCategoriesPersistence({
		page: PAGE_TYPE.COMMUNITY_TRANSFER,
		layoutType: currentLayoutType,
		layout: communityTransferLayout,
		cards: communityTransferCards,
	});

	const handleToggleCategoryCollapse = useCallback(
		(categoryId) => {
			setCollapsedCategoryIds((prev) => {
				const next = {
					...prev,
					[categoryId]: !prev?.[categoryId],
				};
				persistCollapsedCategories(next);

				// Keep Redux in sync AFTER the animation settles so we don't
				// interrupt the 1400ms CategoryBox expand/collapse transition.
				setTimeout(() => {
					dispatch((dispatchArg, getState) => {
						const { communityTransferLayout: currentLayout } = getState().customCard;
						if (!currentLayout) return;
						const synced = applyCollapsedStateToLayout(currentLayout, next);
						dispatchArg(setCommunityTransferLayout(synced));
					});
				}, 1500);

				return next;
			});
		},
		[persistCollapsedCategories, dispatch]
	);

	const prepareScrollToCard = useCallback(
		async (targetId) => {
			if (isLayoutMode) return;
			const lo = getCurrentLayoutV3();
			const categoryId = findCategoryIdContainingCard(lo, targetId);
			if (!categoryId) return;
			const wasCollapsed = Boolean(collapsedCategoryIds[categoryId]);
			if (!wasCollapsed) return;
			// Bring the minimized category into view FIRST so the user can
			// actually see it expand — otherwise the animation plays off-screen.
			const categoryEl = document.querySelector(
				`[data-category-id="${categoryId}"]`
			);
			if (categoryEl) {
				try {
					categoryEl.scrollIntoView({ behavior: 'auto', block: 'center' });
				} catch { /* non-fatal */ }
			}
			await new Promise((resolve) => {
				requestAnimationFrame(() => requestAnimationFrame(resolve));
			});
			setCollapsedCategoryIds((prev) => {
				if (!prev[categoryId]) return prev;
				return { ...prev, [categoryId]: false };
			});
			// Wait for the CategoryBox maximize animation to visibly complete
			// BEFORE the caller scrolls to the target card and fires the
			// highlight flash. Must be >= the enter timing in CategoryBox's
			// Collapse (`timeout.enter`) and the matching outer
			// `.react-grid-item` CSS transition in DragDropLayout
			// (`:has([data-category-id][data-collapsed="false"])`). Both are
			// currently 1400ms — 1500ms adds a tiny buffer.
			await new Promise((resolve) => {
				requestAnimationFrame(() => {
					requestAnimationFrame(() => {
						setTimeout(resolve, 1500);
					});
				});
			});
		},
		[getCurrentLayoutV3, isLayoutMode, collapsedCategoryIds]
	);

	// Card renderer function (same contract as Hospital: single `card` arg).
	// DragDropLayout may call `children(card, idx, isLayoutMode)` for inner grids,
	// but the root grid uses `(gridCard) => renderCard(gridCard)` — extra args are
	// dropped, so layout mode MUST be read from closure, not a parameter.
	const renderCard = useCallback((card) => {
		// Layout-mode fast path: render a per-card-type lightweight preview —
		// same UI shape as the real card, but the body is a dummy skeleton so
		// there are no redux subscriptions, filter math or data fetches during
		// drag. See `features/community-transfer/components/layoutPreview/` and
		// the shared `components/shared/layoutPreview/` module for the details.
		if (isLayoutMode) {
			return (
				<CommunityTransferCardLayoutPreview
					card={card}
					dynamicCards={[
						...(dynamicCards || []),
						...(patientList?.customTabs || []),
					]}
					sharedUsersByTabId={sharedUsersByCustomTabId}
				/>
			);
		}

		switch (card.component) {
			case 'insurance':
				return (
					<CardAnimation id={`${CO_TRANSFER_CARDS_TYPE.INSURANCE_DATA}_scroll`} checked={true} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.COMMUNITY_TRANSFER}
							loading={loading || loadingComparison}
							title={COMMUNITY_CARD_LABELS.insuranceData}
							itemAlign={"ais"}
							priorityNumber={getPriorityNumber(CO_TRANSFER_CARDS_TYPE.INSURANCE_DATA)}
							tooltipContent={tooltipsInfo.communityTrasnferPage.transfersPerInsurance}
							handleOnClickAction={(title, defaultTab) =>
								handleChartDialog(title, CO_TRANSFER_CARDS_TYPE.INSURANCE_DATA, PATIENT_RELATION.INSURANCE, false, defaultTab)
							}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(CO_TRANSFER_CARDS_TYPE.INSURANCE_DATA, title, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, CO_TRANSFER_CARDS_TYPE.INSURANCE_DATA, false)
							}
							selectedItems={cardFilter.insuranceData}
							data={filterListData.insuranceData}
							type={CO_TRANSFER_CARDS_TYPE.INSURANCE_DATA}
							handleToggleAll={handleToggleAll}
							canBeSearched={true}
							cardType={CO_TRANSFER_CARDS_TYPE.INSURANCE_DATA}
							style={{ height: isMobile ? 'auto' : '100%' }}
							disableInteractions={isLayoutMode}
							isMobile={isMobile}
							filterMenuData={{
								type: CO_TRANSFER_CARDS_TYPE.INSURANCE_DATA,
								data: filterListData?.insuranceData || [],
								selectedItem: cardFilter?.insuranceData || [],
							}}
						>
							<InsuranceCard
								cardTitle={COMMUNITY_CARD_LABELS.insuranceData}
								height={350}
								data={filterListData.insuranceData}
								dataComparison={filterListDataComparison?.insuranceData}
								handleToggle={handleToggle}
								handleToggleAll={handleToggleAll}
								selectedItem={cardFilter.insuranceData}
								averageCensus={specialComparisonSet ? filterTotal : percentageAgainst}
								averageCensusComparison={
									specialComparisonSet ? filterTotalComparison : dbDataComparison.censusAverage
								}
								type={"insuranceData"}
								loading={loading || loadingComparison}
								page={PAGE_TYPE.COMMUNITY_TRANSFER}
								filter={filter}
								filterComparison={filterComparison}
								projectionDays={projectionDays}
								isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
								priorityNumber={getPriorityNumber(CO_TRANSFER_CARDS_TYPE.INSURANCE_DATA)}
								transferType={transferType}
								lockedTotalBy={lockedTotalBy}
								disableInteractions={isLayoutMode}
								isMobile={isMobile}
							/>
						</Card>
					</CardAnimation>
				);

			case 'returns':
				return (
					<CardAnimation id={`${CO_TRANSFER_CARDS_TYPE.RETURNS_DATA}_scroll`} checked={true} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.COMMUNITY_TRANSFER}
							loading={loading || loadingComparison}
							title="Returned / Didn't Return"
							priorityNumber={getPriorityNumber(CO_TRANSFER_CARDS_TYPE.RETURNS_DATA)}
							handleOnClickAction={(title, defaultTab) => handleChartDialog(title, CO_TRANSFER_CARDS_TYPE.RETURNS_DATA, null, false, defaultTab)}
							tooltipContent={tooltipsInfo.communityTrasnferPage["returned/didntReturn"]}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(CO_TRANSFER_CARDS_TYPE.RETURNS_DATA, title, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, CO_TRANSFER_CARDS_TYPE.RETURNS_DATA, false)
							}
							cardType={CO_TRANSFER_CARDS_TYPE.RETURNS_DATA}
							style={{ height: isMobile ? 'auto' : '100%' }}
							disableInteractions={isLayoutMode}
							isMobile={isMobile}
							filterMenuData={{
								type: CO_TRANSFER_CARDS_TYPE.RETURNS_DATA,
								data: filterListData?.returnsData || [],
								selectedItem: cardFilter?.returnsData || [],
							}}
						>
							<ReturnCardList
								cardTitle="Returned / Didn't Return"
								handleToggle={handleToggle}
								transfers={dbData.total}
								transfersComparison={dbDataComparison?.total}
								selectedItem={cardFilter.returnsData}
								type={"returnsData"}
								data={filterListData.returnsData}
								comparisonData={filterListDataComparison?.returnsData}
								filter={filter}
								filterComparison={filterComparison}
								page={PAGE_TYPE.COMMUNITY_TRANSFER}
								averageCensus={percentageAgainst}
								averageCensusComparison={dbDataComparison?.censusAverage}
								loading={loading || loadingComparison}
								projectionDays={projectionDays}
								isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
								priorityNumber={getPriorityNumber(CO_TRANSFER_CARDS_TYPE.RETURNS_DATA)}
								transferType={transferType}
								lockedTotalBy={lockedTotalBy}
								disableInteractions={isLayoutMode}
								isMobile={isMobile}
							/>
						</Card>
					</CardAnimation>
				);

			case 'sixtyDays':
				return (
					<CardAnimation id={`${CO_TRANSFER_CARDS_TYPE.SIXTY_DAYS_DATA}_scroll`} checked={true} style={{ height: isMobile ? 'auto' : '100%' }}>
						<Card
							pageType={PAGE_TYPE.COMMUNITY_TRANSFER}
							loading={loading || loadingComparison}
							title="90 Days Analysis"
							priorityNumber={getPriorityNumber(CO_TRANSFER_CARDS_TYPE.SIXTY_DAYS_DATA)}
							tooltipContent={tooltipsInfo.communityTrasnferPage["60DaysAnalysis"]}
							handleOnClickAction={(title, defaultTab) => handleChartDialog(title, CO_TRANSFER_CARDS_TYPE.SIXTY_DAYS_DATA, null, false, defaultTab)}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(CO_TRANSFER_CARDS_TYPE.SIXTY_DAYS_DATA, title, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, CO_TRANSFER_CARDS_TYPE.SIXTY_DAYS_DATA, false)
							}
							cardType={CO_TRANSFER_CARDS_TYPE.SIXTY_DAYS_DATA}
							style={{ height: isMobile ? 'auto' : '100%' }}
							disableInteractions={isLayoutMode}
							isMobile={isMobile}
							filterMenuData={{
								type: CO_TRANSFER_CARDS_TYPE.SIXTY_DAYS_DATA,
								data: filterListData?.sixtyDaysData || [],
								selectedItem: cardFilter?.sixtyDaysData || [],
							}}
						>
							{!isMobile ? (
								<NinetyDaysAnalysis
									cardTitle="90 Days Analysis"
									handleToggle={handleToggle}
									selectedItem={cardFilter.sixtyDaysData}
									type={"sixtyDaysData"}
									loading={loading || loadingComparison}
									data={filterListData.sixtyDaysData}
									comparisonData={filterListDataComparison?.sixtyDaysData}
									page={PAGE_TYPE.COMMUNITY_TRANSFER}
									averageCensus={specialComparisonSet ? filterTotal : percentageAgainst}
									averageCensusComparison={
										specialComparisonSet ? filterTotalComparison : dbDataComparison.censusAverage
									}
									filter={filter}
									filterComparison={filterComparison}
									projectionDays={projectionDays}
									filterTotal={filterTotal}
									isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
									priorityNumber={getPriorityNumber(CO_TRANSFER_CARDS_TYPE.SIXTY_DAYS_DATA)}
									transferType={transferType}
									lockedTotalBy={lockedTotalBy}
									disableInteractions={isLayoutMode}
									isMobile={isMobile}
								/>
							) : (
								<FloorCardList
									cardTitle="90 Days Analysis"
									data={filterListData?.sixtyDaysData?.map(item => ({ ...item, total: item.value })) || []}
									dataComparison={filterListDataComparison?.sixtyDaysData?.map(item => ({ ...item, total: item.value })) || []}
									handleToggle={handleToggle}
									handleToggleAll={handleToggleAll}
									selectedItem={cardFilter.sixtyDaysData}
									type={CO_TRANSFER_CARDS_TYPE.SIXTY_DAYS_DATA}
									page={PAGE_TYPE.COMMUNITY_TRANSFER}
									loading={loading || loadingComparison}
									filter={filter}
									filterComparison={filterComparison}
									averageCensus={specialComparisonSet ? filterTotal : percentageAgainst}
									averageCensusComparison={
										specialComparisonSet ? filterTotalComparison : dbDataComparison.censusAverage
									}
									projectionDays={projectionDays}
									isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
									priorityNumber={getPriorityNumber(CO_TRANSFER_CARDS_TYPE.SIXTY_DAYS_DATA)}
									transferType={transferType}
									lockedTotalBy={lockedTotalBy}
									disableInteractions={isLayoutMode}
									isMobile={isMobile}
								/>
							)}
						</Card>
					</CardAnimation >
				);
			case 'days':
				return (
					<CardAnimation id={`${CO_TRANSFER_CARDS_TYPE.DAYS_DATA}_scroll`} checked={true} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.COMMUNITY_TRANSFER}
							loading={loading || loadingComparison}
							title={COMMUNITY_CARD_LABELS.daysData}
							priorityNumber={getPriorityNumber(CO_TRANSFER_CARDS_TYPE.DAYS_DATA)}
							handleOnClickAction={(title, defaultTab) => handleChartDialog(title, CO_TRANSFER_CARDS_TYPE.DAYS_DATA, null, false, defaultTab)}
							taggedList={
								<TaggedList
									type={CO_TRANSFER_CARDS_TYPE.DAYS_DATA}
									data={filterListData.daysData}
									selectedItem={cardFilter.daysData}
								/>
							}
							filterMenuData={{
								type: CO_TRANSFER_CARDS_TYPE.DAYS_DATA,
								data: filterListData?.daysData || [],
								selectedItem: cardFilter?.daysData || [],
							}}
							tooltipContent={tooltipsInfo.hospitalPage.perDayOfTheWeek}
							isMinimized={true}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(CO_TRANSFER_CARDS_TYPE.DAYS_DATA, title, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, CO_TRANSFER_CARDS_TYPE.DAYS_DATA, false)
							}
							cardType={CO_TRANSFER_CARDS_TYPE.DAYS_DATA}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
						>
							{!isMobile ? (
								<DayCardList
									cardTitle={COMMUNITY_CARD_LABELS.daysData}
									data={filterListData.daysData}
									dataComparison={filterListDataComparison?.daysData}
									handleToggle={handleToggle}
									selectedItem={cardFilter.daysData}
									filter={filter}
									loading={loading || loadingComparison}
									filterComparison={filterComparison}
									type={CO_TRANSFER_CARDS_TYPE.DAYS_DATA}
									page={PAGE_TYPE.COMMUNITY_TRANSFER}
									averageCensus={specialComparisonSet ? filterTotal : getPercentageByTotal(dbData)}
									averageCensusComparison={
										specialComparisonSet ? filterTotalComparison : getPercentageByTotal(dbDataComparison)
									}
									projectionDays={projectionDays}
									filterTotal={filterTotal}
									isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
									priorityNumber={getPriorityNumber(CO_TRANSFER_CARDS_TYPE.DAYS_DATA)}
									transferType={transferType}
									lockedTotalBy={lockedTotalBy}
									disableInteractions={isLayoutMode}
								/>
							) : (
								<FloorCardList
									cardTitle={COMMUNITY_CARD_LABELS.daysData}
									data={filterListData?.daysData?.map(item => ({ ...item, total: item.value })) || []}
									dataComparison={filterListDataComparison?.daysData?.map(item => ({ ...item, total: item.value })) || []}
									handleToggle={handleToggle}
									handleToggleAll={handleToggleAll}
									loading={loading || loadingComparison}
									selectedItem={cardFilter.daysData}
									type={COMMUNITY_CARD_LABELS.DAYS_DATA}
									page={PAGE_TYPE.COMMUNITY_TRANSFER}
									filter={filter}
									filterComparison={filterComparison}
									averageCensus={specialComparisonSet ? filterTotal : getPercentageByTotal(dbData)}
									averageCensusComparison={
										specialComparisonSet ? filterTotalComparison : getPercentageByTotal(dbDataComparison)
									}
									projectionDays={projectionDays}
									filterTotal={filterTotal}
									isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
									priorityNumber={getPriorityNumber(CO_TRANSFER_CARDS_TYPE.DAYS_DATA)}
									transferType={transferType}
									lockedTotalBy={lockedTotalBy}
									disableInteractions={isLayoutMode}
								/>
							)}
						</Card>
					</CardAnimation>
				);
			case 'doctor':
				return (
					<CardAnimation id={`${CO_TRANSFER_CARDS_TYPE.DOCTOR_DATA}_scroll`} checked={true} style={{ height: isMobile ? 'auto' : '100%' }}>
						<Card
							pageType={PAGE_TYPE.COMMUNITY_TRANSFER}
							loading={loading || loadingComparison}
							title={COMMUNITY_CARD_LABELS.doctorData}
							priorityNumber={getPriorityNumber(CO_TRANSFER_CARDS_TYPE.DOCTOR_DATA)}
							handleOnClickAction={(title, defaultTab) =>
								handleChartDialog(title, CO_TRANSFER_CARDS_TYPE.DOCTOR_DATA, PATIENT_RELATION.DOCTOR, false, defaultTab)
							}
							taggedList={
								<TaggedList
									type={"doctorData"}
									data={filterListData.doctorData}
									selectedItem={cardFilter.doctorData}
								/>
							}
							tooltipContent={tooltipsInfo.communityTrasnferPage.perDoctor}
							secondaryTitleError={
								comparingAgainstDifferentFacility &&
								rangesSet &&
								"Trend Analysis disabled when comparing to other facilities"
							}
							secondaryTitleClassName="error"
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(CO_TRANSFER_CARDS_TYPE.DOCTOR_DATA, title, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, CO_TRANSFER_CARDS_TYPE.DOCTOR_DATA, false)
							}
							selectedItems={cardFilter.doctorData}
							data={filterListData.doctorData}
							type={CO_TRANSFER_CARDS_TYPE.DOCTOR_DATA}
							handleToggleAll={handleToggleAll}
							canBeSearched={true}
							cardType={CO_TRANSFER_CARDS_TYPE.DOCTOR_DATA}
							style={{ height: isMobile ? 'auto' : '100%' }}
							disableInteractions={isLayoutMode}
							isMobile={isMobile}
							filterMenuData={{
								type: CO_TRANSFER_CARDS_TYPE.DOCTOR_DATA,
								data: filterListData?.doctorData || [],
								selectedItem: cardFilter?.doctorData || [],
							}}
						>
							<DoctorCard
								cardTitle={COMMUNITY_CARD_LABELS.doctorData}
								data={filterListData.doctorData}
								minimizable={true}
								handleToggle={handleToggle}
								handleToggleAll={handleToggleAll}
								selectedItem={cardFilter.doctorData}
								type={"doctorData"}
								page={PAGE_TYPE.COMMUNITY_TRANSFER}
								comparisonData={filterListDataComparison?.doctorData}
								averageCensus={specialComparisonSet ? filterTotal : percentageAgainst}
								averageCensusComparison={
									specialComparisonSet ? filterTotalComparison : dbDataComparison.censusAverage
								}
								filter={filter}
								loading={loading || loadingComparison}
								filterComparison={filterComparison}
								comparingAgainstDifferentFacility={comparingAgainstDifferentFacility}
								projectionDays={projectionDays}
								isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
								priorityNumber={getPriorityNumber(CO_TRANSFER_CARDS_TYPE.DOCTOR_DATA)}
								transferType={transferType}
								lockedTotalBy={lockedTotalBy}
								disableInteractions={isLayoutMode}
								isMobile={isMobile}
							/>
						</Card>
					</CardAnimation>
				);

			case 'floors':
				return (
					<CardAnimation id={`${CO_TRANSFER_CARDS_TYPE.FLOORS_DATA}_scroll`} checked={true} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.COMMUNITY_TRANSFER}
							loading={loading || loadingComparison}
							title={COMMUNITY_CARD_LABELS.floorsData}
							priorityNumber={getPriorityNumber(CO_TRANSFER_CARDS_TYPE.FLOORS_DATA)}
							handleOnClickAction={(title, defaultTab) =>
								handleChartDialog(title, CO_TRANSFER_CARDS_TYPE.FLOORS_DATA, PATIENT_RELATION.UNIT, false, defaultTab)
							}
							taggedList={
								<TaggedList
									type={"floorsData"}
									data={filterListData.floorsData}
									selectedItem={cardFilter.floorsData}
								/>
							}
							tooltipContent={tooltipsInfo.communityTrasnferPage.floor}
							secondaryTitleError={
								comparingAgainstDifferentFacility &&
								rangesSet &&
								"Trend Analysis disabled when comparing to other facilities"
							}
							secondaryTitleClassName="error"
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(CO_TRANSFER_CARDS_TYPE.FLOORS_DATA, title, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, CO_TRANSFER_CARDS_TYPE.FLOORS_DATA, false)
							}
							selectedItems={cardFilter.floorsData}
							data={filterListData.floorsData}
							type={CO_TRANSFER_CARDS_TYPE.FLOORS_DATA}
							handleToggleAll={handleToggleAll}
							canBeSearched={true}
							cardType={CO_TRANSFER_CARDS_TYPE.FLOORS_DATA}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
							filterMenuData={{
								type: CO_TRANSFER_CARDS_TYPE.FLOORS_DATA,
								data: filterListData?.floorsData || [],
								selectedItem: cardFilter?.floorsData || [],
							}}
						>
							<FloorCardList
								cardTitle={COMMUNITY_CARD_LABELS.floorsData}
								data={filterListData.floorsData}
								handleToggle={handleToggle}
								handleToggleAll={handleToggleAll}
								selectedItem={cardFilter.floorsData}
								type={"floorsData"}
								filter={filter}
								loading={loading || loadingComparison}
								filterComparison={filterComparison}
								page={PAGE_TYPE.COMMUNITY_TRANSFER}
								dataComparison={filterListDataComparison?.floorsData}
								averageCensus={specialComparisonSet ? filterTotal : percentageAgainst}
								averageCensusComparison={
									specialComparisonSet ? filterTotalComparison : dbDataComparison.censusAverage
								}
								comparingAgainstDifferentFacility={comparingAgainstDifferentFacility}
								projectionDays={projectionDays}
								isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
								priorityNumber={getPriorityNumber(CO_TRANSFER_CARDS_TYPE.FLOORS_DATA)}
								transferType={transferType}
								lockedTotalBy={lockedTotalBy}
								disableInteractions={isLayoutMode}
							/>
						</Card>
					</CardAnimation>
				);

			case 'safeDischargeAssLiv':
				return (
					<CardAnimation id={`${CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE_ASS_LIV_DATA}_scroll`} checked={true} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.COMMUNITY_TRANSFER}
							loading={loading || loadingComparison}
							itemAlign="aif"
							title="Safe discharges per Assisted Living"
							priorityNumber={getPriorityNumber(CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE_ASS_LIV_DATA)}
							isDisabled={
								transferType.length !== 0 &&
								!_.includes(transferType, TRANSFER_TYPE.ALL) &&
								!_.includes(transferType, TRANSFER_TYPE.SAFE_DISCHARGE)
							}
							handleOnClickAction={(title, defaultTab) =>
								handleChartDialog(
									title,
									CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE_ASS_LIV_DATA,
									PATIENT_RELATION.TRANSFER_TO_WHICH_ASSISTED_LIVING,
									false,
									defaultTab
								)
							}
							taggedList={
								<TaggedList
									type={"safeDischargeAssLivData"}
									data={filterListData.safeDischargeAssLivData}
									selectedItem={cardFilter.safeDischargeAssLivData}
								/>
							}
							tooltipContent={tooltipsInfo.communityTrasnferPage.safeDischargesPerAssitedLiving}
							isMinimized={true}
							setIsMinimized={(newState) =>
								dispatch(
									setCardExpandState({
										page: "communityPage",
										card: "safeDischarges",
										state: newState,
									})
								)
							}
							selectedItems={cardFilter.safeDischargeAssLivData}
							data={filterListData.safeDischargeAssLivData}
							type={CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE_ASS_LIV_DATA}
							handleToggleAll={handleToggleAll}
							canBeSearched={true}
							cardType={CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE_ASS_LIV_DATA}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
							filterMenuData={{
								type: CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE_ASS_LIV_DATA,
								data: filterListData?.safeDischargeAssLivData || [],
								selectedItem: cardFilter?.safeDischargeAssLivData || [],
							}}
						>
							<>
								{!isMobile && (
									<SafeDischargeAssLivingSlider
										cardTitle="Safe discharges per Assisted Living"
										page={PAGE_TYPE.COMMUNITY_TRANSFER}
										totalSafeDischarge={dbData.totalSafeDischarge}
										totalSafeDischargeComparison={dbDataComparison?.totalSafeDischarge}
										data={filterListData.safeDischargeAssLivData}
										dataComparison={filterListDataComparison?.safeDischargeAssLivData}
										handleToggle={handleToggle}
										handleToggleAll={handleToggleAll}
										selectedItem={cardFilter.safeDischargeAssLivData}
										type={"safeDischargeAssLivData"}
										isDetailsOpen={true}
										filter={filter}
										loading={loading || loadingComparison}
										filterComparison={filterComparison}
										averageCensus={specialComparisonSet ? filterTotal : percentageAgainst}
										averageCensusComparison={
											specialComparisonSet ? filterTotalComparison : dbDataComparison.censusAverage
										}
										projectionDays={projectionDays}
										isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
										priorityNumber={getPriorityNumber(CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE_ASS_LIV_DATA)}
										transferType={transferType}
										lockedTotalBy={lockedTotalBy}
										disableInteractions={isLayoutMode}
										isMobile={isMobile}
									/>
								)}
								{isMobile && (
									<HospitalList
										dbData={dbData}
										dbDataComparison={dbDataComparison}
										cardTitle="Safe discharges per Assisted Living"
										total={dbData.total}
										totalComparison={dbDataComparison?.total}
										data={filterListData.safeDischargeAssLivData}
										dataComparison={filterListDataComparison?.safeDischargeAssLivData}
										filter={filter}
										filterComparison={filterComparison}
										handleToggle={handleToggle}
										selectedItem={cardFilter.safeDischargeAssLivData}
										type={CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE_ASS_LIV_DATA}
										page={PAGE_TYPE.COMMUNITY_TRANSFER}
										loading={loading || loadingComparison}
										comparingAgainstDifferentFacility={comparingAgainstDifferentFacility}
										projectionDays={projectionDays}
										filterTotal={filterTotal}
										averageCensus={percentageAgainst}
										priorityData={cardFilter.mainPriorityData}
										priorityNumber={getPriorityNumber(CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE_ASS_LIV_DATA)}
										transferType={transferType}
										lockedTotalBy={lockedTotalBy}
										disableInteractions={isLayoutMode}
										isMobile={isMobile}
									/>
								)}
							</>
						</Card>
					</CardAnimation>
				);

			case 'snfFacility':
				return (
					<CardAnimation id={`${CO_TRANSFER_CARDS_TYPE.SNF_FACILITY_DATA}_scroll`} checked={true} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.COMMUNITY_TRANSFER}
							loading={loading || loadingComparison}
							title="SNF Transfers per Facility"
							priorityNumber={getPriorityNumber(CO_TRANSFER_CARDS_TYPE.SNF_FACILITY_DATA)}
							isDisabled={
								transferType.length !== 0 &&
								!_.includes(transferType, TRANSFER_TYPE.ALL) &&
								!_.includes(transferType, TRANSFER_TYPE.SNF)
							}
							handleOnClickAction={(title, defaultTab) =>
								handleChartDialog(title, CO_TRANSFER_CARDS_TYPE.SNF_FACILITY_DATA, PATIENT_RELATION.SNF, false, defaultTab)
							}
							taggedList={
								<TaggedList
									type={"snfFacilityData"}
									data={filterListData.snfFacilityData}
									selectedItem={cardFilter.snfFacilityData}
								/>
							}
							secondaryTitleError={
								comparingAgainstDifferentFacility &&
								rangesSet &&
								"Trend Analysis disabled when comparing to other facilities"
							}
							secondaryTitleClassName="error"
							tooltipContent={tooltipsInfo.communityTrasnferPage.snfTransfersPerFacility}
							isMinimized={true}
							setIsMinimized={(newState) =>
								dispatch(
									setCardExpandState({
										page: "communityPage",
										card: "transfers",
										state: newState,
									})
								)
							}
							selectedItems={cardFilter.snfFacilityData}
							data={filterListData.snfFacilityData}
							type={CO_TRANSFER_CARDS_TYPE.SNF_FACILITY_DATA}
							handleToggleAll={handleToggleAll}
							canBeSearched={true}
							cardType={CO_TRANSFER_CARDS_TYPE.SNF_FACILITY_DATA}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
							filterMenuData={{
								type: CO_TRANSFER_CARDS_TYPE.SNF_FACILITY_DATA,
								data: filterListData?.snfFacilityData || [],
								selectedItem: cardFilter?.snfFacilityData || [],
							}}
						>
							{isMobile ? (
								<HospitalList
									dbData={dbData}
									dbDataComparison={dbDataComparison}
									cardTitle="SNF Transfers per Facility"
									total={dbData.total}
									totalComparison={dbDataComparison?.total}
									data={filterListData.snfFacilityData}
									dataComparison={filterListDataComparison?.snfFacilityData}
									filter={filter}
									filterComparison={filterComparison}
									handleToggle={handleToggle}
									selectedItem={cardFilter.snfFacilityData}
									type={CO_TRANSFER_CARDS_TYPE.SNF_FACILITY_DATA}
									page={PAGE_TYPE.COMMUNITY_TRANSFER}
									loading={loading || loadingComparison}
									comparingAgainstDifferentFacility={comparingAgainstDifferentFacility}
									projectionDays={projectionDays}
									filterTotal={filterTotal}
									averageCensus={percentageAgainst}
									priorityData={cardFilter.mainPriorityData}
									priorityNumber={getPriorityNumber(CO_TRANSFER_CARDS_TYPE.SNF_FACILITY_DATA)}
									transferType={transferType}
									lockedTotalBy={lockedTotalBy}
									disableInteractions={isLayoutMode}
									isMobile={isMobile}
								/>
							) : (
								<SNFFacilitySlider
									disableInteractions={isLayoutMode}
									cardTitle="SNF Transfers per Facility"
									data={filterListData.snfFacilityData}
									handleToggle={handleToggle}
									handleToggleAll={handleToggleAll}
									selectedItem={cardFilter.snfFacilityData}
									type={"snfFacilityData"}
									isDetailsOpen={true}
									filter={filter}
									loading={loading || loadingComparison}
									filterComparison={filterComparison}
									dataComparison={filterListDataComparison?.snfFacilityData}
									averageCensus={specialComparisonSet ? filterTotal : percentageAgainst}
									averageCensusComparison={
										specialComparisonSet ? filterTotalComparison : dbDataComparison.censusAverage
									}
									comparingAgainstDifferentFacility={comparingAgainstDifferentFacility}
									projectionDays={projectionDays}
									priorityData={cardFilter.priorityData}
									isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
									priorityNumber={getPriorityNumber(CO_TRANSFER_CARDS_TYPE.SNF_FACILITY_DATA)}
									transferType={transferType}
									lockedTotalBy={lockedTotalBy}
								/>
							)}
						</Card>
					</CardAnimation>
				);

			case 'dynamic':
				return (
					<div style={{ height: '100%' }}>
						<DynamicCardItem
							filterTotal={filterTotal}
							key={card.data?.accessor}
							ele={card.data}
							pageType={PAGE_TYPE.COMMUNITY_TRANSFER}
							selectedCards={communityTransferCards}
							loading={loading}
							loadingComparison={loadingComparison}
							filterListData={filterListData}
							filterListDataComparison={filterListDataComparison}
							cardFilter={cardFilter}
							handleChartDialog={handleChartDialog}
							handleOnClickReport={handleOnClickReport}
							handleOnClickShareReport={handleOnClickShareReport}
							handleToggle={handleToggle}
							handleToggleAll={handleToggleAll}
							filter={filter}
							filterComparison={filterComparison}
							dbData={dbData}
							dbDataComparison={dbDataComparison}
							percentageAgainst={percentageAgainst}
							projectionDays={projectionDays}
							getPriorityNumber={getPriorityNumber}
							transferType={transferType}
							lockedTotalBy={lockedTotalBy}
							isCustomTab={card.data.isCustomTab}
							disableInteractions={isLayoutMode}
							averageCensusComparison={
								specialComparisonSet ? filterTotalComparison : dbDataComparison.censusAverage
							}
							sharedUsersByTabId={sharedUsersByCustomTabId}
							sharedWithEveryoneByTabId={sharedWithEveryoneByTabId}
						/>
					</div>
				);

			default:
				return null;
		}
	}, [
		isLayoutMode,
		loading,
		loadingComparison,
		filterListData,
		filterListDataComparison,
		cardFilter,
		handleChartDialog,
		handleOnClickReport,
		handleOnClickShareReport,
		handleToggle,
		handleToggleAll,
		filter,
		filterComparison,
		dbData,
		dbDataComparison,
		percentageAgainst,
		projectionDays,
		getPriorityNumber,
		transferType,
		lockedTotalBy,
		comparingAgainstDifferentFacility,
		rangesSet,
		communityTransferCards,
		filterTotal,
		specialComparisonSet,
		filterTotalComparison,
		dispatch,
		isMobile,
		sharedUsersByCustomTabId,
		sharedWithEveryoneByTabId,
		dynamicCards,
		patientList?.customTabs,
	]);

	const handleAddCustomCard = useCallback(async (key) => {
		let cards = [...communityTransferCards];
		if (key === "selectAll") {
			cards = _.map(COMMUNITY_CUSTOM_CARD_DATA, "value");
		} else if (key === "clearAll") {
			cards = []
		} else {
			if (!cards.includes(key)) {
				cards.push(key);
			} else {
				cards.splice(cards.indexOf(key), 1);
			}
		}
		dispatch(setCommunityTransferCards(cards));
	}, [COMMUNITY_CUSTOM_CARD_DATA, communityTransferCards, dispatch]);

	// Auto-select all custom cards once everything is rendered
	useEffect(() => {
		// Check if data is loaded, not loading, and we have the necessary data
		if (dbData && !loading && !communityLoading && activeFacilities && activeFacilities.length > 0) {
			// Always ensure all available cards are selected for all users
			const allAvailableValues = COMMUNITY_CUSTOM_CARD_DATA.map(card => card.value);
			const missingCards = allAvailableValues.filter(val => !communityTransferCards.includes(val));
			
			if (missingCards.length > 0) {
				const updatedCards = [...communityTransferCards, ...missingCards];
				dispatch(setCommunityTransferCards(updatedCards));
			}
		}
	}, [dbData, loading, communityLoading, activeFacilities, communityTransferCards, dispatch, COMMUNITY_CUSTOM_CARD_DATA]);

	const [scrollPosition, setScrollPosition] = useState({ scrollTop: 0 });
	const scrollDemoRef = useRef(null);
	const handleScroll = () => {
		if (scrollDemoRef.current) {
			const { scrollTop } = scrollDemoRef.current;
			setScrollPosition({ scrollTop });
		}
	};

	useEffect(() => {
		if (scrollDemoRef.current) {
			scrollDemoRef.current.style.overflowY = "auto";
			scrollDemoRef.current.style.overflowX = isLayoutMode ? "hidden" : "";
		}
		document.body.style.overflow = "";
		document.body.style.backgroundColor = "";
		return () => {
			if (scrollDemoRef.current) {
				// eslint-disable-next-line react-hooks/exhaustive-deps
				scrollDemoRef.current.style.overflowY = "";
				// eslint-disable-next-line react-hooks/exhaustive-deps
				scrollDemoRef.current.style.overflowX = "";
			}
			document.body.style.overflow = "";
			document.body.style.backgroundColor = "";
		};
	}, [isLayoutMode]);

	const layoutZoomWrapperRef = useRef(null);
	const layoutZoomScale = isMobile
		? COMMUNITY_TRANSFER_LAYOUT_MODE_ZOOM_MOBILE
		: COMMUNITY_TRANSFER_LAYOUT_MODE_ZOOM_DESKTOP;
	useLayoutEffect(() => {
		const node = layoutZoomWrapperRef.current;
		if (!node) return undefined;
		if (!isLayoutMode) {
			node.style.marginBottom = "";
			return undefined;
		}
		let raf = null;
		const update = () => {
			const natural = node.offsetHeight;
			if (!(natural > 0)) return;
			const negative = natural * (1 - layoutZoomScale);
			node.style.marginBottom = `-${negative}px`;
		};
		update();
		let ro;
		if (typeof ResizeObserver !== "undefined") {
			ro = new ResizeObserver(() => {
				if (raf) cancelAnimationFrame(raf);
				raf = requestAnimationFrame(update);
			});
			ro.observe(node);
		}
		return () => {
			if (raf) cancelAnimationFrame(raf);
			if (ro) ro.disconnect();
			node.style.marginBottom = "";
		};
	}, [isLayoutMode, layoutZoomScale]);

	const handleDisableCustomCard = useCallback((ele) => {
		if (transferType.length === 0) {
			return false;
		} else {
			return !_.includes(transferType, ele?.forTransferType) ? true : false;
		}

	}, [transferType]);

	// AI Chat handlers
	const handleAiChatToggle = useCallback(() => {
		setAiChatOpen(!aiChatOpen);
		if (!aiChatOpen) {
			setAiChatUnreadCount(0);
		}
	}, [aiChatOpen]);

	const handleAiChatClose = useCallback(() => {
		setAiChatOpen(false);
		setAiChatMinimized(false);
	}, []);

	const handleAiChatMinimizeStateChange = useCallback((isMinimized) => {
		setAiChatMinimized(isMinimized);
	}, []);

	// handleVectorStoreIdUpdate — disabled (new agent API never invokes this callback)
	/*
	const handleVectorStoreIdUpdate = useCallback((vectorStoreId) => {
		setAiVectorStoreId(vectorStoreId);

		// Vector store caching + cleanup registration — disabled (new agent API does not use vector stores)
		// Cache the vector store ID for the current context
		const cacheKey = getVectorStoreCacheKey();
		if (cacheKey && vectorStoreId) {
			localStorage.setItem(cacheKey, vectorStoreId);

			// Register for cleanup on logout
			registerVectorStoreId(vectorStoreId, 'communityTransfer');
		}
	}, [getVectorStoreCacheKey]);
	*/

	// State for default chart data for AI analysis
	const [defaultChartData, setDefaultChartData] = useState({
		chartData: null,
		aggregationType: 'unknown',
		currentFilter: null
	});

	// Generate default chart data for AI analysis (weekly view by default)
	useEffect(() => {
		const generateChartData = async () => {
			if (!patientList?.list || patientList.list.length === 0 || !filter) {
				setDefaultChartData({
					chartData: null,
					aggregationType: 'unknown',
					currentFilter: null
				});
				return;
			}

			try {
				const patientDataWithFacility = patientList.list.map((patient) => ({
					...patient,
					facilityName: patient?.facility?.name || 'Unknown'
				}));

				const chartDataArr = await chartsData(patientDataWithFacility, filter);

				const censusByPeriodData = patientList.censusByPeriod || [];
				const censusAverageData = String(getPercentageByTotal({
					censusAverage: patientList.censusAverage,
					total: patientList.list.length
				}));

				const latestChartData = await chartGroupBy(
					chartDataArr,
					'week',
					censusAverageData,
					censusByPeriodData,
					filter
				);

				setDefaultChartData({
					chartData: latestChartData || [],
					aggregationType: 'weekly',
					currentFilter: 'week'
				});
			} catch (error) {
				console.error('⚠️ Error generating default chart data:', error);
				setDefaultChartData({
					chartData: null,
					aggregationType: 'unknown',
					currentFilter: null
				});
			}
		};

		generateChartData();
	}, [patientList, filter]);

	// Prepare AI chat context data using the new modular hooks
	const aiChatContext = useAIChatContext({
		// Page identification
		pageType: PAGE_TYPE.COMMUNITY_TRANSFER, // CRITICAL: Identifies this as Community Transfer page for correct API endpoint and vector store

		dbData,
		filterListData,
		patientList,
		activeFacilities,
		facilities,
		dynamicCards,

		filter,
		transferType,
		cardFilter,
		percentageBy,
		lockedTotalBy,
		specialComparisonSet,
		filterTotal,
		percentageAgainst,
		projectionDays,
		lastADTDate,

		communityTransferCards,
		rangesSet,
		isLayoutMode,

		getPriorityNumber,
		lockedTotal,
		lockedByFacility,
		isCensusTotalLocked,
		facilityPercentage,

		COMMUNITY_CUSTOM_CARD_DATA,
		tooltipsInfo,

		// Service dependencies — disabled (services not initialized; optional chaining inside the hook handles undefined)
		/*
		aiCensusActionsService,
		aiReportActionsService,
		aiTransferActionsService,
		aiDialogActionsService,
		aiDateSuggestionsService,
		*/

		chartData: defaultChartData.chartData,
		chartAggregationType: defaultChartData.aggregationType,
		currentChartFilter: defaultChartData.currentFilter
	});

	// Pre-load AI conversation with comprehensive context for faster responses
	const preloadAIConversation = useCallback(async () => {
		try {
			if (aiContextPreloaded || !patientList?.list?.length || !filterListData || !aiChatContext) {
				return;
			}

			const { default: aiChatService } = await import('../services/ai-chat.service');

			const preloadMessage = `Initialize conversation context for Community Transfer dashboard analysis. 
			Data loaded: ${aiChatContext.pageData.metrics.totalTransfers} total transfers, 
			${aiChatContext.pageData.filters.facilities.count} facilities, 
			${aiChatContext.pageData.currentState.availableDataCategories.length} card types available.
			Ready for user questions about community transfer data and analytics.`;

			const response = await aiChatService.preloadConversation(preloadMessage, aiChatContext);

			if (response?.conversationId) {
				setAiConversationId(response.conversationId);
				setAiContextPreloaded(true);
			}
		} catch (error) {
			console.error('Error pre-loading AI conversation:', error);
			// Don't throw error - this is an optimization, not critical functionality
		}
	}, [aiContextPreloaded, aiChatContext, patientList, filterListData]);

	return (
		<Page title="Dashboard: Community Transfer">
			{detailsDialog.isOpen && (
				<CommunityTransferCardDetailsDialog
					handleOnClickReport={handleOnClickReportGraph}
					handleOnClickShareReport={handleOnClickShareReport}
					handleGenerateExcelReport={downloadExcel}
				/>
			)}
			<div
				id="scroll-container"
				ref={scrollDemoRef}
				className={dashboardStyles.content}
				onScroll={handleScroll}
				style={{
					position: 'relative',
					...(isLayoutMode ? { overflowX: 'hidden' } : {}),
				}}
			>
				{/* Layout Type Loading Overlay */}
				{layoutTypeLoading && (
					<div style={{
						position: 'fixed',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: 'rgba(255, 255, 255, 0.9)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						zIndex: 99999,
						flexDirection: 'column',
						gap: '16px'
					}}>
						<CircularProgress size={40} />
						<div style={{ fontSize: '16px', color: '#333', fontWeight: '500' }}>Loading layout...</div>
					</div>
				)}

				{!isLayoutMode && (
					<div className={`df aic ${styles.header}`}>
						<div className={`df aic ${styles.aoWrapper}`}>
							<CommunityTransferHeader
								filterListData={filterListData}
								handleFilterUpdate={() => setIsDateUpdated(true)}
								loading={loading || loadingComparison}
								setLoading={setLoading}
								setLoadingComparison={setLoadingComparison}
								projectionDays={projectionDays}
								isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
								percentageAgainst={percentageAgainst}
								dynamicCards={communityTransferHeaderPopoverDynamicCards}
								renderCardFilterPopover={renderCommunityTransferCardFilterPopover}
								interactiveHeaderFilterPopoverSlowTransition
								isOnlyHospitalDashboard={isOnlyHospitalDashboard}
								isLayoutMode={isLayoutMode}
								isMobile={isMobile}
								disableInteractions={isLayoutMode}
								isHeaderVisible={isHeaderVisible}
								setIsHeaderVisible={setIsHeaderVisible}
								isDataFromCache={isDataFromCache}
								pageConverterPatientList={
									pageConverterPatientSource !== null
										? pageConverterPatientSource
										: Array.isArray(patientList?.list)
											? patientList.list
											: []
								}
								pageConverterFilter={filter}
							/>
						</div>
					</div>
				)}
				{(loading || communityLoading) ?
					<div style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						height: "90vh"
					}}>
						<CircularProgress />
					</div> : (
						<Box
							ref={layoutZoomWrapperRef}
							sx={{
								...(isLayoutMode
									? {
										transform: `scale(${isMobile ? COMMUNITY_TRANSFER_LAYOUT_MODE_ZOOM_MOBILE : COMMUNITY_TRANSFER_LAYOUT_MODE_ZOOM_DESKTOP})`,
										transformOrigin: 'top left',
										width: `calc(100% / ${isMobile ? COMMUNITY_TRANSFER_LAYOUT_MODE_ZOOM_MOBILE : COMMUNITY_TRANSFER_LAYOUT_MODE_ZOOM_DESKTOP})`,
										maxWidth: 'none',
										transition: 'transform 0.22s ease-out, width 0.22s ease-out',
										willChange: 'transform',
									}
									: {}),
							}}
						>
							<NoteContainer page={PAGE_TYPE.COMMUNITY_TRANSFER} isMobile={isMobile} isHeaderVisible={isHeaderVisible}>
								<Grid container justifyContent={"center"} sx={{ mt: "30px" }}>
									<Grid item xs={12} position={"relative"}>
										{rangesSet && !isMobile && <ColorInfoBox style={{ zIndex: 100, right: "1%" }} loading={loading || loadingComparison} isLayoutMode={isLayoutMode} />}
										{!isMobile && (
											<AddCardDrawer
												listData={COMMUNITY_CUSTOM_CARD_DATA}
												selectedCards={communityTransferCards}
												handleAddCustomCard={handleAddCustomCard}
												scrollTop={scrollPosition?.scrollTop}
												transferType={transferType}
												filter={filter}
												isLayoutMode={isLayoutMode}
												pinTopInLayoutMode={true}
												prepareScrollToCard={prepareScrollToCard}
											/>
										)}
										<TotalCountCircle
											isHeaderVisible={isHeaderVisible}
											isLayoutMode={isLayoutMode}
											loading={loading || loadingComparison}
											page={PAGE_TYPE.COMMUNITY_TRANSFER}
											totalTitle="Total Community Transfers"
											projectTitle={percentageBy}
											selected={_.includes(transferType, TRANSFER_TYPE.ALL)}
											handleClickTotal={() => {
												triggerFilterTutorial();
												handleClickTotal(calcProPercentsBasedOnFilterAndDays(dbData.total, filter, projectionDays))
											}}
											total={dbData.total}
											totalComparison={dbDataComparison?.total}
											filter={filter}
											filterComparison={filterComparison}
											totalPercentage={itemPercentage(dbData.total, percentageAgainst, "number")}
											totalComparisonPercentage={itemPercentage(
												dbDataComparison?.total,
												dbDataComparison?.censusAverage,
												"number"
											)}
											projectTotal={projectionPerMonth(dbData.total, filter, projectionDays)}
											projectTotalComparison={projectionPerMonth(dbDataComparison?.total, filterComparison, projectionDays)}
											totalProjectionPercentage={itemPercentage(
												projectionPerMonth(dbData.total, filter, projectionDays),
												percentageAgainst,
												"number"
											)}
											totalProjectionComparisonPercentage={itemPercentage(
												projectionPerMonth(dbDataComparison?.total, filterComparison, true),
												dbDataComparison?.censusAverage,
												"number"
											)}
											tooltipContent={tooltipsInfo.communityTrasnferPage.totalCommunityTransfers}
											handleOnClickAction={(title, defaultTab) => handleChartDialog(title, CO_TRANSFER_CARDS_TYPE.TOTAL, null, true, defaultTab)}
											handleOnClickReport={(title, otherData) =>
												handleOnClickReport(CO_TRANSFER_CARDS_TYPE.TOTAL, title, true, otherData)
											}
											handleOnClickShareReport={(title) => handleOnClickShareReport(title, CO_TRANSFER_CARDS_TYPE.TOTAL, true)}
											projectionDays={projectionDays}
											totalCardType={"total"}
											isMobile={isMobile}
										/>
									</Grid>
								</Grid>

								<Box sx={{ p: 2, pl: 2, pr: 2 }}>
									<Grid container spacing={isMobile ? 0 : 2} direction={"row"}>
										{/* Transfer Type Selection Cards */}
										{isMobile && (
											<Grid item xs={12}>
												<MobileTransferCarousel
													loading={loading || loadingComparison}
													selected={transferType}
													handleSelectCard={handleClickCardTransferType}
													dbData={dbData}
													dbDataComparison={dbDataComparison}
													filter={filter}
													filterComparison={filterComparison}
													percentageAgainst={percentageAgainst}
													percentageBy={percentageBy}
													projectionDays={projectionDays}
													handleClickCardTransferType={handleClickCardTransferType}
													handleOnClickAction={(title, defaultTab) => handleChartDialog(title, CO_TRANSFER_CARDS_TYPE.TOTAL, null, true, defaultTab)}
													handleOnClickReport={handleOnClickReport}
													tooltipsInfo={tooltipsInfo}
													isLayoutMode={isLayoutMode}
												/>
											</Grid>
										)}
										{!isMobile && (<>
											<Grid item md={4} xs={12}>
												<SelectableCardCoTransfer
													pageType={PAGE_TYPE.COMMUNITY_TRANSFER}
													title="Safe Discharges"
													loading={loading || loadingComparison}
													selected={_.includes(transferType, TRANSFER_TYPE.SAFE_DISCHARGE)}
													handleOnclickCard={(e) => {
														triggerFilterTutorial();
														handleClickCardTransferType(e, TRANSFER_TYPE.SAFE_DISCHARGE)
													}}
													tooltipContent={tooltipsInfo.communityTrasnferPage.safeDischarges}
													handleOnClickAction={(title, defaultTab) => handleChartDialog(title, CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE, null, true, defaultTab)}
													handleOnClickReport={(title, otherData) =>
														handleOnClickReport("totalSafeDischarge", title, true, otherData)
													}
													handleOnClickShareReport={(title) =>
														handleOnClickShareReport(title, CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE, true)
													}
													disabled={isLayoutMode}
													isLayoutMode={isLayoutMode}
												>
													<TotalCoTransferCard
														loading={loading || loadingComparison}
														selected={_.includes(transferType, TRANSFER_TYPE.SAFE_DISCHARGE)}
														type={TRANSFER_TYPE.SAFE_DISCHARGE}
														handleSelectCard={handleClickCardTransferType}
														page={PAGE_TYPE.COMMUNITY_TRANSFER}
														title={"Total Safe Discharges"}
														dbData={dbData}
														dbDataComparison={dbDataComparison}
														total={dbData.totalSafeDischarge}
														totalComparison={dbDataComparison?.totalSafeDischarge}
														totalComparisonPercentage={itemPercentage(
															dbDataComparison?.totalSafeDischarge,
															dbDataComparison?.censusAverage,
															"number"
														)}
														filter={filter}
														filterComparison={filterComparison}
														totalPercentage={itemPercentage(dbData.totalSafeDischarge, percentageAgainst, "number")}
														totalProjection={projectionPerMonth(dbData.totalSafeDischarge, filter, projectionDays)}
														totalProjectionComparison={projectionPerMonth(
															dbDataComparison?.totalSafeDischarge,
															filterComparison,
															projectionDays
														)}
														totalProjectionPercentage={itemPercentage(
															projectionPerMonth(dbData.totalSafeDischarge, filter, projectionDays),
															percentageAgainst,
															"number"
														)}
														totalProjectionComparisonPercentage={itemPercentage(
															projectionPerMonth(dbDataComparison?.totalSafeDischarge, filterComparison),
															dbDataComparison?.censusAverage,
															"number"
														)}
														secondaryTitle={percentageBy}
														secondaryText={percentageBy}
														projectionDays={projectionDays}
													/>
												</SelectableCardCoTransfer>
											</Grid>
											<Grid item md={4} xs={12}>
												<SelectableCardCoTransfer
													pageType={PAGE_TYPE.COMMUNITY_TRANSFER}
													flex="1"
													loading={loading || loadingComparison}
													title="SNF Transfers"
													selected={_.includes(transferType, TRANSFER_TYPE.SNF)}
													handleOnclickCard={(e) => {
														triggerFilterTutorial();
														handleClickCardTransferType(e, TRANSFER_TYPE.SNF)
													}}
													tooltipContent={tooltipsInfo.communityTrasnferPage.snf}
													handleOnClickAction={(title, defaultTab) => handleChartDialog(title, CO_TRANSFER_CARDS_TYPE.SNF, null, true, defaultTab)}
													handleOnClickReport={(title, otherData) => handleOnClickReport("totalSNF", title, true, otherData)}
													handleOnClickShareReport={(title) =>
														handleOnClickShareReport(title, CO_TRANSFER_CARDS_TYPE.SNF, true)
													}
													isLayoutMode={isLayoutMode}
													disabled={isLayoutMode}
												>
													<TotalCoTransferCard
														loading={loading || loadingComparison}
														selected={_.includes(transferType, TRANSFER_TYPE.SNF)}
														type={TRANSFER_TYPE.SNF}
														handleSelectCard={handleClickCardTransferType}
														page={PAGE_TYPE.COMMUNITY_TRANSFER}
														title={"Total SNF Transfers"}
														total={dbData.totalSNF}
														totalComparison={dbDataComparison?.totalSNF}
														filter={filter}
														filterComparison={filterComparison}
														totalComparisonPercentage={itemPercentage(
															dbDataComparison?.totalSNF,
															dbDataComparison?.censusAverage,
															"number"
														)}
														totalPercentage={itemPercentage(dbData.totalSNF, percentageAgainst, "number")}
														totalProjection={projectionPerMonth(dbData.totalSNF, filter, projectionDays)}
														totalProjectionComparison={projectionPerMonth(
															dbDataComparison?.totalSNF,
															filterComparison,
															projectionDays
														)}
														totalProjectionPercentage={itemPercentage(
															projectionPerMonth(dbData.totalSNF, filter, projectionDays),
															percentageAgainst,
															"number"
														)}
														totalProjectionComparisonPercentage={itemPercentage(
															projectionPerMonth(dbDataComparison?.totalSNF, filterComparison),
															dbDataComparison?.censusAverage,
															"number"
														)}
														secondaryTitle={percentageBy}
														secondaryText={percentageBy}
														projectionDays={projectionDays}
													/>
												</SelectableCardCoTransfer>
											</Grid>
											<Grid item md={4} xs={12}>
												<SelectableCardCoTransfer
													pageType={PAGE_TYPE.COMMUNITY_TRANSFER}
													flex="1"
													title="AMA"
													loading={loading || loadingComparison}
													selected={_.includes(transferType, TRANSFER_TYPE.AMA)}
													handleOnclickCard={(e) => {
														triggerFilterTutorial();
														handleClickCardTransferType(e, TRANSFER_TYPE.AMA)
													}}
													tooltipContent={tooltipsInfo.communityTrasnferPage.ama}
													handleOnClickAction={(title, defaultTab) => handleChartDialog(title, CO_TRANSFER_CARDS_TYPE.AMA, null, true, defaultTab)}
													handleOnClickReport={(title, otherData) => handleOnClickReport("totalAMA", title, true, otherData)}
													handleOnClickShareReport={(title) =>
														handleOnClickShareReport(title, CO_TRANSFER_CARDS_TYPE.AMA, true)
													}
													isLayoutMode={isLayoutMode}
													disabled={isLayoutMode}
												>
													<TotalCoTransferCard
														loading={loading || loadingComparison}
														selected={_.includes(transferType, TRANSFER_TYPE.AMA)}
														type={TRANSFER_TYPE.AMA}
														handleSelectCard={handleClickCardTransferType}
														page={PAGE_TYPE.COMMUNITY_TRANSFER}
														title={"Total AMA Transfers"}
														total={dbData.totalAMA}
														totalComparison={dbDataComparison?.totalAMA}
														filter={filter}
														filterComparison={filterComparison}
														totalPercentage={itemPercentage(dbData.totalAMA, percentageAgainst, "number")}
														totalComparisonPercentage={itemPercentage(
															dbDataComparison?.totalAMA,
															dbDataComparison?.censusAverage,
															"number"
														)}
														totalProjection={projectionPerMonth(dbData.totalAMA, filter, projectionDays)}
														totalProjectionComparison={projectionPerMonth(
															dbDataComparison?.totalAMA,
															filterComparison,
															projectionDays
														)}
														totalProjectionPercentage={itemPercentage(
															projectionPerMonth(dbData.totalAMA, filter, projectionDays),
															percentageAgainst,
															"number"
														)}
														totalProjectionComparisonPercentage={itemPercentage(
															projectionPerMonth(dbDataComparison?.totalAMA, filterComparison),
															dbDataComparison?.censusAverage,
															"number"
														)}
														secondaryTitle={percentageBy}
														secondaryText={percentageBy}
														projectionDays={projectionDays}
													/>
												</SelectableCardCoTransfer>
											</Grid>
										</>
										)}

										<ShadowLineWithText data={communityTransferCards} />

										{/* Drag & Drop Layout for Cards */}
										{isV3LayoutActive ? (
											<Box sx={{ width: "100%", mt: 2, mb: 2, pb: 1, pl: 2, pr: 2 }}>
												{(() => {
													const lo = getCurrentLayoutV3();
													const { layoutForDrag, cardsForGrid } = communityMainGridPayload;
													const hasRoot =
														(lo.categories?.length || 0) + (lo.standalone?.length || 0) > 0;
													if (!isLayoutMode && (!hasRoot || cardsForGrid.length === 0)) return null;
													const categoryIdSet = new Set((lo.categories || []).map((c) => c.id));
													const hasStandaloneCards = (lo.standalone?.length || 0) > 0;
													const showStandaloneFallbackDropZone =
														isLayoutMode &&
														!hasStandaloneCards &&
														(Boolean(draggedCardId) || Boolean(draggedCardIdRef.current)) &&
														dragSource &&
														dragSource !== "standalone";

													return (
														<>
															<DragDropLayout
																isBoundedLayout={true}
																cards={cardsForGrid}
																layout={layoutForDrag}
																onLayoutChange={handleRootGridChange}
																isLayoutMode={isLayoutMode}
																disabled={loading || communityLoading}
																isMobile={isMobile}
																uniformCardHeight={false}
																strictOverlapReorder
																strictOverlapThreshold={0.62}
																draggableCancel=".hospital-category-inner-dnd"
																hospitalRootLayoutMarker
																enableRootGaps={isLayoutMode}
																onRootGapDrop={handleRootGapDrop}
																layoutScrollContainerRef={scrollDemoRef}
																transformScale={
																	isLayoutMode
																		? (isMobile
																			? COMMUNITY_TRANSFER_LAYOUT_MODE_ZOOM_MOBILE
																			: COMMUNITY_TRANSFER_LAYOUT_MODE_ZOOM_DESKTOP)
																		: 1
																}
																generalDropHighlight={communityGeneralDropHighlight}
																shouldPersistLayoutAfterDrag={() => {
																	if (!isLayoutMode) return true;
																	const dragging =
																		draggedCardId || draggedCardIdRef.current;
																	if (dragging && hoveredCategoryId != null) return false;
																	return true;
																}}
																onDragStart={(layout, oldItem, newItem) => {
																	const id = newItem?.i;
																	if (!id) return;
																	if (categoryIdSet.has(id)) {
																		draggedCardIdRef.current = null;
																		dragSourceRef.current = null;
																		setDraggedCardId(null);
																		setDragSource(null);
																		setHoveredCategoryId(null);
																		setHoveredStandalone(false);
																		return;
																	}
																	draggedCardIdRef.current = id;
																	dragSourceRef.current = "standalone";
																	setDraggedCardId(id);
																	setDragSource("standalone");
																	setHoveredCategoryId(null);
																	setHoveredStandalone(true);
																}}
																onDragStop={(layout, oldItem, newItem, placeholder, e) => {
																	// Bulletproof Drop: Use the exact coordinates at release to find the target.
																	const pt = getPointerClientCoords(e);
																	let targetId = hoveredCategoryId;

																	if (pt) {
																		const cid = resolveHospitalCategoryIdUnderPointer(pt.x, pt.y);
																		if (cid) targetId = cid;
																	}

																	if (targetId != null) {
																		handleCardDrop(targetId, "General Cards", e);
																	}
																	setTimeout(() => {
																		draggedCardIdRef.current = null;
																		dragSourceRef.current = null;
																		setDraggedCardId(null);
																		setHoveredCategoryId(null);
																		setHoveredStandalone(false);
																		setDragSource(null);
																	}, 50);
																}}
															>
																{(gridCard) => {
																	if (gridCard.type === "category") {
																		const category = lo.categories.find((c) => c.id === gridCard.id);
																		if (!category) return null;
																		const categoryCards = (category.cards || [])
																			.map((cardItem) => {
																				const def = cardData.find((c) => c.id === cardItem.id);
																				return def ? { ...def, ...cardItem } : null;
																			})
																			.filter(Boolean);
																		return (
																			<CategoryBox
																				id={category.id}
																				title={category.title}
																				cards={categoryCards}
																				dynamicCards={[...(dynamicCards || []), ...(patientList?.customTabs || [])]}
																				isCollapsed={Boolean(collapsedCategoryIds[category.id])}
																				onToggleCollapse={handleToggleCategoryCollapse}
																				onLayoutChange={handleLayoutChangeInCategory}
																				onDelete={handleDeleteCategory}
																				onUpdateTitle={handleUpdateCategoryTitle}
																				renderCard={renderCard}
																				isLayoutMode={isLayoutMode}
																				loading={loading || communityLoading}
																				isMobile={isMobile}
																				innerTwoColumnDesktop={categoryInnerTwoCol}
																				layoutScrollContainerRef={scrollDemoRef}
																				useNativeCategoryReorder={false}
																				transformScale={
																					isLayoutMode
																						? (isMobile
																							? COMMUNITY_TRANSFER_LAYOUT_MODE_ZOOM_MOBILE
																							: COMMUNITY_TRANSFER_LAYOUT_MODE_ZOOM_DESKTOP)
																						: 1
																				}
																				onMouseEnter={(cid) => {
																					setHoveredCategoryId(cid);
																					setHoveredStandalone(false);
																				}}
																				onMouseLeave={() => setHoveredCategoryId(null)}
																				draggedCardId={draggedCardId}
																				dragSourceId={dragSource}
																				hoveredCategoryId={hoveredCategoryId}
																				hoveredStandalone={hoveredStandalone}
																				suppressCategoryInnerPersistRef={
																					suppressCategoryInnerPersistRef
																				}
																				onInnerLayoutDrag={(layout, oldItem, newItem, placeholder, ev) => {
																					const c = getPointerClientCoords(ev);
																					if (c) categoryDragPointerRef.current = c;
																				}}
																				onDragStart={(cardId, sourceCategoryId) => {
																					categoryDragPointerRef.current = null;
																					draggedCardIdRef.current = cardId;
																					dragSourceRef.current = sourceCategoryId;
																					setDraggedCardId(cardId);
																					setDragSource(sourceCategoryId);
																					setHoveredCategoryId(null);
																					setHoveredStandalone(false);
																				}}
																				onDragStop={(cardId, sourceCategoryId, e) => {
																					const pt =
																						getPointerClientCoords(e) ||
																						categoryDragPointerRef.current ||
																						(Date.now() - lastPointerRef.current.timestamp < 500
																							? lastPointerRef.current
																							: null);
																					let droppedOnStandalone = false;
																					const zoneEl = standaloneDropZoneRef.current;
																					if (pt && zoneEl) {
																						const r = zoneEl.getBoundingClientRect();
																						if (pointInRect(pt, r)) {
																							droppedOnStandalone = true;
																						}
																					}
																					if (!droppedOnStandalone && pt) {
																						let el = document.elementFromPoint(pt.x, pt.y);
																						if (!el?.closest?.("[data-hospital-drop='standalone']")) {
																							const offsets = [[5, 0], [-5, 0], [0, 5], [0, -5]];
																							for (const [dx, dy] of offsets) {
																								el = document.elementFromPoint(pt.x + dx, pt.y + dy);
																								if (el?.closest?.("[data-hospital-drop='standalone']")) break;
																							}
																						}
																						if (el?.closest?.("[data-hospital-drop='standalone']")) {
																							droppedOnStandalone = true;
																						}
																					}
																					if (!droppedOnStandalone && hoveredStandaloneRef.current) {
																						droppedOnStandalone = true;
																					}
																					if (!droppedOnStandalone && pt && pointerOverHospitalRootStandaloneArea(pt)) {
																						droppedOnStandalone = true;
																					}
																					categoryDragPointerRef.current = null;
																					const geometricTargetCategoryId =
																						!droppedOnStandalone && pt
																							? resolveHospitalCategoryIdUnderPointer(pt.x, pt.y)
																							: null;
																					if (droppedOnStandalone) {
																						suppressCategoryInnerPersistRef.current = true;
																						handleCardDrop("standalone", "General Cards", e);
																					} else if (
																						geometricTargetCategoryId != null &&
																						geometricTargetCategoryId !== category.id
																					) {
																						suppressCategoryInnerPersistRef.current = true;
																						handleCardDrop(geometricTargetCategoryId, "General Cards", e);
																					} else if (hoveredCategoryId != null && hoveredCategoryId !== category.id) {
																						suppressCategoryInnerPersistRef.current = true;
																						handleCardDrop(hoveredCategoryId, "General Cards", e);
																					} else {
																						setTimeout(() => {
																							draggedCardIdRef.current = null;
																							dragSourceRef.current = null;
																							setDraggedCardId(null);
																							setHoveredCategoryId(null);
																							setHoveredStandalone(false);
																							setDragSource(null);
																						}, 50);
																					}
																					queueMicrotask(() => {
																						suppressCategoryInnerPersistRef.current = false;
																					});
																				}}
																				onCardDrop={() => handleCardDrop(category.id, category.title)}
																				onCardDropAtEdge={handleCardDropAtCategoryEdge}
																				isCardOver={hoveredCategoryId === category.id}
																				showDropSuccessFlash={dropFlashCategoryId === category.id}
																			/>
																		);
																	}
																	return renderCard(gridCard);
																}}
															</DragDropLayout>
															{showStandaloneFallbackDropZone && (
																<Box
																	ref={standaloneDropZoneRef}
																	data-hospital-drop="standalone"
																	onMouseEnter={() =>
																		(draggedCardId || draggedCardIdRef.current) &&
																		setHoveredStandalone(true)
																	}
																	onMouseLeave={() => setHoveredStandalone(false)}
																	onMouseUp={(ev) => handleCardDrop("standalone", "General Cards", ev)}
																	sx={{
																		mb: 2,
																		ml: 1,
																		mt: 1,
																		px: 1,
																		py: 2,
																		minHeight: 88,
																		position: "relative",
																		zIndex: 10,
																		border: "1px dashed rgba(224, 228, 234, 0.95)",
																		borderRadius: "8px",
																		backgroundColor: "rgba(250, 251, 252, 0.95)",
																	}}
																>
																	<Typography variant="body2" color="text.secondary" align="center">
																		Drop here to move a card to the general area (no general cards in the
																		grid yet)
																	</Typography>
																</Box>
															)}
														</>
													);
												})()}
											</Box>
										) : (
											<DragDropLayout
												isBoundedLayout={true}
												cards={cardData}
												layout={getLegacyFlatLayout()}
												onLayoutChange={handleLayoutChange}
												isLayoutMode={isLayoutMode}
												disabled={loading || communityLoading}
												isMobile={isMobile}
												strictOverlapReorder
												strictOverlapThreshold={0.62}
												transformScale={
													isLayoutMode
														? (isMobile
															? COMMUNITY_TRANSFER_LAYOUT_MODE_ZOOM_MOBILE
															: COMMUNITY_TRANSFER_LAYOUT_MODE_ZOOM_DESKTOP)
														: 1
												}
											>
												{renderCard}
											</DragDropLayout>
										)}
									</Grid>
								</Box>
							</NoteContainer>
						</Box>)
				}
			</div>

			{/* Share Notification Dialog for Community Transfer Page */}
			<ShareNotificationDialog
				open={showShareDialog && !mobileMenuOpen}
				notifications={shareNotifications}
				onClose={handleCloseShareDialog}
				onResponse={handleNotificationResponse}
				onViewTab={handleViewTab}
			/>

			{/* Layout Controller for Drag-and-Drop */}
			<LayoutController
				isLayoutMode={isLayoutMode}
				onToggleLayoutMode={handleToggleLayoutMode}
				onSaveLayout={handleSaveLayout}
				onResetLayout={handleResetLayout}
				hasChanges={hasLayoutChanges}
				disabled={loading || communityLoading}
				onLayoutTypeChange={handleLayoutTypeChange}
				currentLayoutType={currentLayoutType}
				pageType={PAGE_TYPE.COMMUNITY_TRANSFER}
				onCreateCategory={handleCreateCategory}
				onAddCategoryFromMenu={handleAddCategoryFromMenu}
			/>

			{/* Toast Notification */}
			<ToastNotification
				open={toastNotification.open}
				type={toastNotification.type}
				title={toastNotification.title}
				message={toastNotification.message}
				onClose={() => setToastNotification({ ...toastNotification, open: false })}
			/>

			{/* AI Chat Float Button - Only show when drawer is closed or maximized and user has access */}
			{hasAiChatAccess && !aiChatAccessLoading && !isLayoutMode && (!aiChatOpen || !aiChatMinimized) && (
				<AiChatFloatButton
					onClick={handleAiChatToggle}
					isOpen={aiChatOpen}
					unreadCount={aiChatUnreadCount}
					disabled={loading || communityLoading || !dbData}
					showPulse={!loading && !communityLoading && dbData && !aiChatOpen}
					tooltipText="Ask AI about your community transfer data"
				/>
			)}

			{/* AI Chat Drawer - Only show if user has access */}
			{hasAiChatAccess && !aiChatAccessLoading && (
				<AiChatDrawer
					open={aiChatOpen}
					onClose={handleAiChatClose}
					pageType={PAGE_TYPE.COMMUNITY_TRANSFER}
					pageData={aiChatContext}
					onMinimizeStateChange={handleAiChatMinimizeStateChange}
					handleOnClickReport={handleOnClickReport}
					downloadExcel={downloadExcel}
					conversationId={aiConversationId}
					contextPreloaded={aiContextPreloaded}
					filter={filter}
					disabled={loading || communityLoading || !dbData}
					loadingMessage={loading || communityLoading ? "Loading community transfer data... Please wait before asking questions." : undefined}
				/>
			)}

			{/* Share Report Dialog */}
			{shareReportState.open && (
				<ShareNotesDialog
					handleClose={handleCloseShareReport}
					handleSubmit={handleShareReport}
					isShare={shareReportState.open}
					noteText={`Report: ${shareReportState.reportTitle || 'Generated Report'}`}
					users={users}
					availableIntegrations={availableIntegrations}
					isSubmitting={shareReportState.isSharing}
					accountId={accountIdFromHook}
					facilityId={facilityIdFromHook}
					redirectAfter={handleCloseShareReport}
				/>
			)}
		</Page>
	);
};

export default CommunityTransferPage;
